import { jsx as I, jsxs as he } from "react/jsx-runtime";
import { createContext as G, useState as ee, useRef as W, useCallback as D, useEffect as Q, useMemo as F, useContext as k } from "react";
import { useQueryClient as Yr, useQuery as pe, QueryClientProvider as Qr, QueryClient as Xr, keepPreviousData as Zr } from "@tanstack/react-query";
import { Dialog as en } from "primereact/dialog";
import { Button as tn } from "primereact/button";
import { useAuth as rn } from "react-oidc-context";
import { Toast as nn } from "primereact/toast";
function Xt(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: sn } = Object.prototype, { getPrototypeOf: it } = Object, { iterator: Ue, toStringTag: Zt } = Symbol, ke = /* @__PURE__ */ ((e) => (t) => {
  const r = sn.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Z = (e) => (e = e.toLowerCase(), (t) => ke(t) === e), Fe = (e) => (t) => typeof t === e, { isArray: le } = Array, ue = Fe("undefined");
function me(e) {
  return e !== null && !ue(e) && e.constructor !== null && !ue(e.constructor) && J(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const er = Z("ArrayBuffer");
function an(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && er(e.buffer), t;
}
const on = Fe("string"), J = Fe("function"), tr = Fe("number"), ye = (e) => e !== null && typeof e == "object", cn = (e) => e === !0 || e === !1, Ce = (e) => {
  if (ke(e) !== "object")
    return !1;
  const t = it(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Zt in e) && !(Ue in e);
}, un = (e) => {
  if (!ye(e) || me(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, ln = Z("Date"), dn = Z("File"), fn = (e) => !!(e && typeof e.uri < "u"), pn = (e) => e && typeof e.getParts < "u", hn = Z("Blob"), mn = Z("FileList"), yn = (e) => ye(e) && J(e.pipe);
function gn() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const bt = gn(), St = typeof bt.FormData < "u" ? bt.FormData : void 0, bn = (e) => {
  let t;
  return e && (St && e instanceof St || J(e.append) && ((t = ke(e)) === "formdata" || // detect form-data instance
  t === "object" && J(e.toString) && e.toString() === "[object FormData]"));
}, Sn = Z("URLSearchParams"), [wn, Rn, En, Tn] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(Z), An = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function ge(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, s;
  if (typeof e != "object" && (e = [e]), le(e))
    for (n = 0, s = e.length; n < s; n++)
      t.call(null, e[n], n, e);
  else {
    if (me(e))
      return;
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), a = o.length;
    let i;
    for (n = 0; n < a; n++)
      i = o[n], t.call(null, e[i], i, e);
  }
}
function rr(e, t) {
  if (me(e))
    return null;
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, s;
  for (; n-- > 0; )
    if (s = r[n], t === s.toLowerCase())
      return s;
  return null;
}
const ne = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, nr = (e) => !ue(e) && e !== ne;
function Ze() {
  const { caseless: e, skipUndefined: t } = nr(this) && this || {}, r = {}, n = (s, o) => {
    if (o === "__proto__" || o === "constructor" || o === "prototype")
      return;
    const a = e && rr(r, o) || o;
    Ce(r[a]) && Ce(s) ? r[a] = Ze(r[a], s) : Ce(s) ? r[a] = Ze({}, s) : le(s) ? r[a] = s.slice() : (!t || !ue(s)) && (r[a] = s);
  };
  for (let s = 0, o = arguments.length; s < o; s++)
    arguments[s] && ge(arguments[s], n);
  return r;
}
const Cn = (e, t, r, { allOwnKeys: n } = {}) => (ge(
  t,
  (s, o) => {
    r && J(s) ? Object.defineProperty(e, o, {
      value: Xt(s, r),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, o, {
      value: s,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: n }
), e), vn = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), In = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), Object.defineProperty(e.prototype, "constructor", {
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, On = (e, t, r, n) => {
  let s, o, a;
  const i = {};
  if (t = t || {}, e == null) return t;
  do {
    for (s = Object.getOwnPropertyNames(e), o = s.length; o-- > 0; )
      a = s[o], (!n || n(a, e, t)) && !i[a] && (t[a] = e[a], i[a] = !0);
    e = r !== !1 && it(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, Pn = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, xn = (e) => {
  if (!e) return null;
  if (le(e)) return e;
  let t = e.length;
  if (!tr(t)) return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, _n = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && it(Uint8Array)), Ln = (e, t) => {
  const n = (e && e[Ue]).call(e);
  let s;
  for (; (s = n.next()) && !s.done; ) {
    const o = s.value;
    t.call(e, o[0], o[1]);
  }
}, Nn = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, qn = Z("HTMLFormElement"), jn = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(r, n, s) {
  return n.toUpperCase() + s;
}), wt = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), Un = Z("RegExp"), sr = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  ge(r, (s, o) => {
    let a;
    (a = t(s, o, e)) !== !1 && (n[o] = a || s);
  }), Object.defineProperties(e, n);
}, kn = (e) => {
  sr(e, (t, r) => {
    if (J(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if (J(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, Fn = (e, t) => {
  const r = {}, n = (s) => {
    s.forEach((o) => {
      r[o] = !0;
    });
  };
  return le(e) ? n(e) : n(String(e).split(t)), r;
}, Dn = () => {
}, Bn = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function $n(e) {
  return !!(e && J(e.append) && e[Zt] === "FormData" && e[Ue]);
}
const Mn = (e) => {
  const t = new Array(10), r = (n, s) => {
    if (ye(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (me(n))
        return n;
      if (!("toJSON" in n)) {
        t[s] = n;
        const o = le(n) ? [] : {};
        return ge(n, (a, i) => {
          const c = r(a, s + 1);
          !ue(c) && (o[i] = c);
        }), t[s] = void 0, o;
      }
    }
    return n;
  };
  return r(e, 0);
}, zn = Z("AsyncFunction"), Gn = (e) => e && (ye(e) || J(e)) && J(e.then) && J(e.catch), ar = ((e, t) => e ? setImmediate : t ? ((r, n) => (ne.addEventListener(
  "message",
  ({ source: s, data: o }) => {
    s === ne && o === r && n.length && n.shift()();
  },
  !1
), (s) => {
  n.push(s), ne.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(typeof setImmediate == "function", J(ne.postMessage)), Hn = typeof queueMicrotask < "u" ? queueMicrotask.bind(ne) : typeof process < "u" && process.nextTick || ar, Vn = (e) => e != null && J(e[Ue]), f = {
  isArray: le,
  isArrayBuffer: er,
  isBuffer: me,
  isFormData: bn,
  isArrayBufferView: an,
  isString: on,
  isNumber: tr,
  isBoolean: cn,
  isObject: ye,
  isPlainObject: Ce,
  isEmptyObject: un,
  isReadableStream: wn,
  isRequest: Rn,
  isResponse: En,
  isHeaders: Tn,
  isUndefined: ue,
  isDate: ln,
  isFile: dn,
  isReactNativeBlob: fn,
  isReactNative: pn,
  isBlob: hn,
  isRegExp: Un,
  isFunction: J,
  isStream: yn,
  isURLSearchParams: Sn,
  isTypedArray: _n,
  isFileList: mn,
  forEach: ge,
  merge: Ze,
  extend: Cn,
  trim: An,
  stripBOM: vn,
  inherits: In,
  toFlatObject: On,
  kindOf: ke,
  kindOfTest: Z,
  endsWith: Pn,
  toArray: xn,
  forEachEntry: Ln,
  matchAll: Nn,
  isHTMLForm: qn,
  hasOwnProperty: wt,
  hasOwnProp: wt,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: sr,
  freezeMethods: kn,
  toObjectSet: Fn,
  toCamelCase: jn,
  noop: Dn,
  toFiniteNumber: Bn,
  findKey: rr,
  global: ne,
  isContextDefined: nr,
  isSpecCompliantForm: $n,
  toJSONObject: Mn,
  isAsyncFn: zn,
  isThenable: Gn,
  setImmediate: ar,
  asap: Hn,
  isIterable: Vn
};
let E = class or extends Error {
  static from(t, r, n, s, o, a) {
    const i = new or(t.message, r || t.code, n, s, o);
    return i.cause = t, i.name = t.name, t.status != null && i.status == null && (i.status = t.status), a && Object.assign(i, a), i;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(t, r, n, s, o) {
    super(t), Object.defineProperty(this, "message", {
      value: t,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, r && (this.code = r), n && (this.config = n), s && (this.request = s), o && (this.response = o, this.status = o.status);
  }
  toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: f.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
};
E.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
E.ERR_BAD_OPTION = "ERR_BAD_OPTION";
E.ECONNABORTED = "ECONNABORTED";
E.ETIMEDOUT = "ETIMEDOUT";
E.ERR_NETWORK = "ERR_NETWORK";
E.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
E.ERR_DEPRECATED = "ERR_DEPRECATED";
E.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
E.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
E.ERR_CANCELED = "ERR_CANCELED";
E.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
E.ERR_INVALID_URL = "ERR_INVALID_URL";
const Wn = null;
function et(e) {
  return f.isPlainObject(e) || f.isArray(e);
}
function ir(e) {
  return f.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function We(e, t, r) {
  return e ? e.concat(t).map(function(s, o) {
    return s = ir(s), !r && o ? "[" + s + "]" : s;
  }).join(r ? "." : "") : t;
}
function Jn(e) {
  return f.isArray(e) && !e.some(et);
}
const Kn = f.toFlatObject(f, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function De(e, t, r) {
  if (!f.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = f.toFlatObject(
    r,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(m, h) {
      return !f.isUndefined(h[m]);
    }
  );
  const n = r.metaTokens, s = r.visitor || u, o = r.dots, a = r.indexes, c = (r.Blob || typeof Blob < "u" && Blob) && f.isSpecCompliantForm(t);
  if (!f.isFunction(s))
    throw new TypeError("visitor must be a function");
  function d(p) {
    if (p === null) return "";
    if (f.isDate(p))
      return p.toISOString();
    if (f.isBoolean(p))
      return p.toString();
    if (!c && f.isBlob(p))
      throw new E("Blob is not supported. Use a Buffer instead.");
    return f.isArrayBuffer(p) || f.isTypedArray(p) ? c && typeof Blob == "function" ? new Blob([p]) : Buffer.from(p) : p;
  }
  function u(p, m, h) {
    let S = p;
    if (f.isReactNative(t) && f.isReactNativeBlob(p))
      return t.append(We(h, m, o), d(p)), !1;
    if (p && !h && typeof p == "object") {
      if (f.endsWith(m, "{}"))
        m = n ? m : m.slice(0, -2), p = JSON.stringify(p);
      else if (f.isArray(p) && Jn(p) || (f.isFileList(p) || f.endsWith(m, "[]")) && (S = f.toArray(p)))
        return m = ir(m), S.forEach(function(O, P) {
          !(f.isUndefined(O) || O === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            a === !0 ? We([m], P, o) : a === null ? m : m + "[]",
            d(O)
          );
        }), !1;
    }
    return et(p) ? !0 : (t.append(We(h, m, o), d(p)), !1);
  }
  const l = [], g = Object.assign(Kn, {
    defaultVisitor: u,
    convertValue: d,
    isVisitable: et
  });
  function w(p, m) {
    if (!f.isUndefined(p)) {
      if (l.indexOf(p) !== -1)
        throw Error("Circular reference detected in " + m.join("."));
      l.push(p), f.forEach(p, function(S, v) {
        (!(f.isUndefined(S) || S === null) && s.call(t, S, f.isString(v) ? v.trim() : v, m, g)) === !0 && w(S, m ? m.concat(v) : [v]);
      }), l.pop();
    }
  }
  if (!f.isObject(e))
    throw new TypeError("data must be an object");
  return w(e), t;
}
function Rt(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function ct(e, t) {
  this._pairs = [], e && De(e, this, t);
}
const cr = ct.prototype;
cr.append = function(t, r) {
  this._pairs.push([t, r]);
};
cr.toString = function(t) {
  const r = t ? function(n) {
    return t.call(this, n, Rt);
  } : Rt;
  return this._pairs.map(function(s) {
    return r(s[0]) + "=" + r(s[1]);
  }, "").join("&");
};
function Yn(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function ur(e, t, r) {
  if (!t)
    return e;
  const n = r && r.encode || Yn, s = f.isFunction(r) ? {
    serialize: r
  } : r, o = s && s.serialize;
  let a;
  if (o ? a = o(t, s) : a = f.isURLSearchParams(t) ? t.toString() : new ct(t, s).toString(n), a) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return e;
}
class Et {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    f.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const ut = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0
}, Qn = typeof URLSearchParams < "u" ? URLSearchParams : ct, Xn = typeof FormData < "u" ? FormData : null, Zn = typeof Blob < "u" ? Blob : null, es = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Qn,
    FormData: Xn,
    Blob: Zn
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, lt = typeof window < "u" && typeof document < "u", tt = typeof navigator == "object" && navigator || void 0, ts = lt && (!tt || ["ReactNative", "NativeScript", "NS"].indexOf(tt.product) < 0), rs = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", ns = lt && window.location.href || "http://localhost", ss = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: lt,
  hasStandardBrowserEnv: ts,
  hasStandardBrowserWebWorkerEnv: rs,
  navigator: tt,
  origin: ns
}, Symbol.toStringTag, { value: "Module" })), M = {
  ...ss,
  ...es
};
function as(e, t) {
  return De(e, new M.classes.URLSearchParams(), {
    visitor: function(r, n, s, o) {
      return M.isNode && f.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function os(e) {
  return f.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function is(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const s = r.length;
  let o;
  for (n = 0; n < s; n++)
    o = r[n], t[o] = e[o];
  return t;
}
function lr(e) {
  function t(r, n, s, o) {
    let a = r[o++];
    if (a === "__proto__") return !0;
    const i = Number.isFinite(+a), c = o >= r.length;
    return a = !a && f.isArray(s) ? s.length : a, c ? (f.hasOwnProp(s, a) ? s[a] = [s[a], n] : s[a] = n, !i) : ((!s[a] || !f.isObject(s[a])) && (s[a] = []), t(r, n, s[a], o) && f.isArray(s[a]) && (s[a] = is(s[a])), !i);
  }
  if (f.isFormData(e) && f.isFunction(e.entries)) {
    const r = {};
    return f.forEachEntry(e, (n, s) => {
      t(os(n), s, r, 0);
    }), r;
  }
  return null;
}
function cs(e, t, r) {
  if (f.isString(e))
    try {
      return (t || JSON.parse)(e), f.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(e);
}
const be = {
  transitional: ut,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(t, r) {
      const n = r.getContentType() || "", s = n.indexOf("application/json") > -1, o = f.isObject(t);
      if (o && f.isHTMLForm(t) && (t = new FormData(t)), f.isFormData(t))
        return s ? JSON.stringify(lr(t)) : t;
      if (f.isArrayBuffer(t) || f.isBuffer(t) || f.isStream(t) || f.isFile(t) || f.isBlob(t) || f.isReadableStream(t))
        return t;
      if (f.isArrayBufferView(t))
        return t.buffer;
      if (f.isURLSearchParams(t))
        return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
      let i;
      if (o) {
        if (n.indexOf("application/x-www-form-urlencoded") > -1)
          return as(t, this.formSerializer).toString();
        if ((i = f.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
          const c = this.env && this.env.FormData;
          return De(
            i ? { "files[]": t } : t,
            c && new c(),
            this.formSerializer
          );
        }
      }
      return o || s ? (r.setContentType("application/json", !1), cs(t)) : t;
    }
  ],
  transformResponse: [
    function(t) {
      const r = this.transitional || be.transitional, n = r && r.forcedJSONParsing, s = this.responseType === "json";
      if (f.isResponse(t) || f.isReadableStream(t))
        return t;
      if (t && f.isString(t) && (n && !this.responseType || s)) {
        const a = !(r && r.silentJSONParsing) && s;
        try {
          return JSON.parse(t, this.parseReviver);
        } catch (i) {
          if (a)
            throw i.name === "SyntaxError" ? E.from(i, E.ERR_BAD_RESPONSE, this, null, this.response) : i;
        }
      }
      return t;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: M.classes.FormData,
    Blob: M.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
f.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  be.headers[e] = {};
});
const us = f.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), ls = (e) => {
  const t = {};
  let r, n, s;
  return e && e.split(`
`).forEach(function(a) {
    s = a.indexOf(":"), r = a.substring(0, s).trim().toLowerCase(), n = a.substring(s + 1).trim(), !(!r || t[r] && us[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, Tt = Symbol("internals");
function de(e) {
  return e && String(e).trim().toLowerCase();
}
function ve(e) {
  return e === !1 || e == null ? e : f.isArray(e) ? e.map(ve) : String(e);
}
function ds(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const fs = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Je(e, t, r, n, s) {
  if (f.isFunction(n))
    return n.call(this, t, r);
  if (s && (t = r), !!f.isString(t)) {
    if (f.isString(n))
      return t.indexOf(n) !== -1;
    if (f.isRegExp(n))
      return n.test(t);
  }
}
function ps(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function hs(e, t) {
  const r = f.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      value: function(s, o, a) {
        return this[n].call(this, t, s, o, a);
      },
      configurable: !0
    });
  });
}
let K = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, n) {
    const s = this;
    function o(i, c, d) {
      const u = de(c);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const l = f.findKey(s, u);
      (!l || s[l] === void 0 || d === !0 || d === void 0 && s[l] !== !1) && (s[l || c] = ve(i));
    }
    const a = (i, c) => f.forEach(i, (d, u) => o(d, u, c));
    if (f.isPlainObject(t) || t instanceof this.constructor)
      a(t, r);
    else if (f.isString(t) && (t = t.trim()) && !fs(t))
      a(ls(t), r);
    else if (f.isObject(t) && f.isIterable(t)) {
      let i = {}, c, d;
      for (const u of t) {
        if (!f.isArray(u))
          throw TypeError("Object iterator must return a key-value pair");
        i[d = u[0]] = (c = i[d]) ? f.isArray(c) ? [...c, u[1]] : [c, u[1]] : u[1];
      }
      a(i, r);
    } else
      t != null && o(r, t, n);
    return this;
  }
  get(t, r) {
    if (t = de(t), t) {
      const n = f.findKey(this, t);
      if (n) {
        const s = this[n];
        if (!r)
          return s;
        if (r === !0)
          return ds(s);
        if (f.isFunction(r))
          return r.call(this, s, n);
        if (f.isRegExp(r))
          return r.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = de(t), t) {
      const n = f.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!r || Je(this, this[n], n, r)));
    }
    return !1;
  }
  delete(t, r) {
    const n = this;
    let s = !1;
    function o(a) {
      if (a = de(a), a) {
        const i = f.findKey(n, a);
        i && (!r || Je(n, n[i], i, r)) && (delete n[i], s = !0);
      }
    }
    return f.isArray(t) ? t.forEach(o) : o(t), s;
  }
  clear(t) {
    const r = Object.keys(this);
    let n = r.length, s = !1;
    for (; n--; ) {
      const o = r[n];
      (!t || Je(this, this[o], o, t, !0)) && (delete this[o], s = !0);
    }
    return s;
  }
  normalize(t) {
    const r = this, n = {};
    return f.forEach(this, (s, o) => {
      const a = f.findKey(n, o);
      if (a) {
        r[a] = ve(s), delete r[o];
        return;
      }
      const i = t ? ps(o) : String(o).trim();
      i !== o && delete r[o], r[i] = ve(s), n[i] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return f.forEach(this, (n, s) => {
      n != null && n !== !1 && (r[s] = t && f.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    const n = new this(t);
    return r.forEach((s) => n.set(s)), n;
  }
  static accessor(t) {
    const n = (this[Tt] = this[Tt] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function o(a) {
      const i = de(a);
      n[i] || (hs(s, a), n[i] = !0);
    }
    return f.isArray(t) ? t.forEach(o) : o(t), this;
  }
};
K.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
f.reduceDescriptors(K.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(n) {
      this[r] = n;
    }
  };
});
f.freezeMethods(K);
function Ke(e, t) {
  const r = this || be, n = t || r, s = K.from(n.headers);
  let o = n.data;
  return f.forEach(e, function(i) {
    o = i.call(r, o, s.normalize(), t ? t.status : void 0);
  }), s.normalize(), o;
}
function dr(e) {
  return !!(e && e.__CANCEL__);
}
let Se = class extends E {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(t, r, n) {
    super(t ?? "canceled", E.ERR_CANCELED, r, n), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function fr(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(
    new E(
      "Request failed with status code " + r.status,
      [E.ERR_BAD_REQUEST, E.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
      r.config,
      r.request,
      r
    )
  );
}
function ms(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function ys(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let s = 0, o = 0, a;
  return t = t !== void 0 ? t : 1e3, function(c) {
    const d = Date.now(), u = n[o];
    a || (a = d), r[s] = c, n[s] = d;
    let l = o, g = 0;
    for (; l !== s; )
      g += r[l++], l = l % e;
    if (s = (s + 1) % e, s === o && (o = (o + 1) % e), d - a < t)
      return;
    const w = u && d - u;
    return w ? Math.round(g * 1e3 / w) : void 0;
  };
}
function gs(e, t) {
  let r = 0, n = 1e3 / t, s, o;
  const a = (d, u = Date.now()) => {
    r = u, s = null, o && (clearTimeout(o), o = null), e(...d);
  };
  return [(...d) => {
    const u = Date.now(), l = u - r;
    l >= n ? a(d, u) : (s = d, o || (o = setTimeout(() => {
      o = null, a(s);
    }, n - l)));
  }, () => s && a(s)];
}
const Pe = (e, t, r = 3) => {
  let n = 0;
  const s = ys(50, 250);
  return gs((o) => {
    const a = o.loaded, i = o.lengthComputable ? o.total : void 0, c = a - n, d = s(c), u = a <= i;
    n = a;
    const l = {
      loaded: a,
      total: i,
      progress: i ? a / i : void 0,
      bytes: c,
      rate: d || void 0,
      estimated: d && i && u ? (i - a) / d : void 0,
      event: o,
      lengthComputable: i != null,
      [t ? "download" : "upload"]: !0
    };
    e(l);
  }, r);
}, At = (e, t) => {
  const r = e != null;
  return [
    (n) => t[0]({
      lengthComputable: r,
      total: e,
      loaded: n
    }),
    t[1]
  ];
}, Ct = (e) => (...t) => f.asap(() => e(...t)), bs = M.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (r) => (r = new URL(r, M.origin), e.protocol === r.protocol && e.host === r.host && (t || e.port === r.port)))(
  new URL(M.origin),
  M.navigator && /(msie|trident)/i.test(M.navigator.userAgent)
) : () => !0, Ss = M.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, r, n, s, o, a) {
      if (typeof document > "u") return;
      const i = [`${e}=${encodeURIComponent(t)}`];
      f.isNumber(r) && i.push(`expires=${new Date(r).toUTCString()}`), f.isString(n) && i.push(`path=${n}`), f.isString(s) && i.push(`domain=${s}`), o === !0 && i.push("secure"), f.isString(a) && i.push(`SameSite=${a}`), document.cookie = i.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const t = document.cookie.match(new RegExp("(?:^|; )" + e + "=([^;]*)"));
      return t ? decodeURIComponent(t[1]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function ws(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Rs(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function pr(e, t, r) {
  let n = !ws(t);
  return e && (n || r == !1) ? Rs(e, t) : t;
}
const vt = (e) => e instanceof K ? { ...e } : e;
function oe(e, t) {
  t = t || {};
  const r = {};
  function n(d, u, l, g) {
    return f.isPlainObject(d) && f.isPlainObject(u) ? f.merge.call({ caseless: g }, d, u) : f.isPlainObject(u) ? f.merge({}, u) : f.isArray(u) ? u.slice() : u;
  }
  function s(d, u, l, g) {
    if (f.isUndefined(u)) {
      if (!f.isUndefined(d))
        return n(void 0, d, l, g);
    } else return n(d, u, l, g);
  }
  function o(d, u) {
    if (!f.isUndefined(u))
      return n(void 0, u);
  }
  function a(d, u) {
    if (f.isUndefined(u)) {
      if (!f.isUndefined(d))
        return n(void 0, d);
    } else return n(void 0, u);
  }
  function i(d, u, l) {
    if (l in t)
      return n(d, u);
    if (l in e)
      return n(void 0, d);
  }
  const c = {
    url: o,
    method: o,
    data: o,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    withXSRFToken: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    beforeRedirect: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    responseEncoding: a,
    validateStatus: i,
    headers: (d, u, l) => s(vt(d), vt(u), l, !0)
  };
  return f.forEach(Object.keys({ ...e, ...t }), function(u) {
    if (u === "__proto__" || u === "constructor" || u === "prototype") return;
    const l = f.hasOwnProp(c, u) ? c[u] : s, g = l(e[u], t[u], u);
    f.isUndefined(g) && l !== i || (r[u] = g);
  }), r;
}
const hr = (e) => {
  const t = oe({}, e);
  let { data: r, withXSRFToken: n, xsrfHeaderName: s, xsrfCookieName: o, headers: a, auth: i } = t;
  if (t.headers = a = K.from(a), t.url = ur(
    pr(t.baseURL, t.url, t.allowAbsoluteUrls),
    e.params,
    e.paramsSerializer
  ), i && a.set(
    "Authorization",
    "Basic " + btoa(
      (i.username || "") + ":" + (i.password ? unescape(encodeURIComponent(i.password)) : "")
    )
  ), f.isFormData(r)) {
    if (M.hasStandardBrowserEnv || M.hasStandardBrowserWebWorkerEnv)
      a.setContentType(void 0);
    else if (f.isFunction(r.getHeaders)) {
      const c = r.getHeaders(), d = ["content-type", "content-length"];
      Object.entries(c).forEach(([u, l]) => {
        d.includes(u.toLowerCase()) && a.set(u, l);
      });
    }
  }
  if (M.hasStandardBrowserEnv && (n && f.isFunction(n) && (n = n(t)), n || n !== !1 && bs(t.url))) {
    const c = s && o && Ss.read(o);
    c && a.set(s, c);
  }
  return t;
}, Es = typeof XMLHttpRequest < "u", Ts = Es && function(e) {
  return new Promise(function(r, n) {
    const s = hr(e);
    let o = s.data;
    const a = K.from(s.headers).normalize();
    let { responseType: i, onUploadProgress: c, onDownloadProgress: d } = s, u, l, g, w, p;
    function m() {
      w && w(), p && p(), s.cancelToken && s.cancelToken.unsubscribe(u), s.signal && s.signal.removeEventListener("abort", u);
    }
    let h = new XMLHttpRequest();
    h.open(s.method.toUpperCase(), s.url, !0), h.timeout = s.timeout;
    function S() {
      if (!h)
        return;
      const O = K.from(
        "getAllResponseHeaders" in h && h.getAllResponseHeaders()
      ), A = {
        data: !i || i === "text" || i === "json" ? h.responseText : h.response,
        status: h.status,
        statusText: h.statusText,
        headers: O,
        config: e,
        request: h
      };
      fr(
        function(T) {
          r(T), m();
        },
        function(T) {
          n(T), m();
        },
        A
      ), h = null;
    }
    "onloadend" in h ? h.onloadend = S : h.onreadystatechange = function() {
      !h || h.readyState !== 4 || h.status === 0 && !(h.responseURL && h.responseURL.indexOf("file:") === 0) || setTimeout(S);
    }, h.onabort = function() {
      h && (n(new E("Request aborted", E.ECONNABORTED, e, h)), h = null);
    }, h.onerror = function(P) {
      const A = P && P.message ? P.message : "Network Error", C = new E(A, E.ERR_NETWORK, e, h);
      C.event = P || null, n(C), h = null;
    }, h.ontimeout = function() {
      let P = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const A = s.transitional || ut;
      s.timeoutErrorMessage && (P = s.timeoutErrorMessage), n(
        new E(
          P,
          A.clarifyTimeoutError ? E.ETIMEDOUT : E.ECONNABORTED,
          e,
          h
        )
      ), h = null;
    }, o === void 0 && a.setContentType(null), "setRequestHeader" in h && f.forEach(a.toJSON(), function(P, A) {
      h.setRequestHeader(A, P);
    }), f.isUndefined(s.withCredentials) || (h.withCredentials = !!s.withCredentials), i && i !== "json" && (h.responseType = s.responseType), d && ([g, p] = Pe(d, !0), h.addEventListener("progress", g)), c && h.upload && ([l, w] = Pe(c), h.upload.addEventListener("progress", l), h.upload.addEventListener("loadend", w)), (s.cancelToken || s.signal) && (u = (O) => {
      h && (n(!O || O.type ? new Se(null, e, h) : O), h.abort(), h = null);
    }, s.cancelToken && s.cancelToken.subscribe(u), s.signal && (s.signal.aborted ? u() : s.signal.addEventListener("abort", u)));
    const v = ms(s.url);
    if (v && M.protocols.indexOf(v) === -1) {
      n(
        new E(
          "Unsupported protocol " + v + ":",
          E.ERR_BAD_REQUEST,
          e
        )
      );
      return;
    }
    h.send(o || null);
  });
}, As = (e, t) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (t || r) {
    let n = new AbortController(), s;
    const o = function(d) {
      if (!s) {
        s = !0, i();
        const u = d instanceof Error ? d : this.reason;
        n.abort(
          u instanceof E ? u : new Se(u instanceof Error ? u.message : u)
        );
      }
    };
    let a = t && setTimeout(() => {
      a = null, o(new E(`timeout of ${t}ms exceeded`, E.ETIMEDOUT));
    }, t);
    const i = () => {
      e && (a && clearTimeout(a), a = null, e.forEach((d) => {
        d.unsubscribe ? d.unsubscribe(o) : d.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((d) => d.addEventListener("abort", o));
    const { signal: c } = n;
    return c.unsubscribe = () => f.asap(i), c;
  }
}, Cs = function* (e, t) {
  let r = e.byteLength;
  if (r < t) {
    yield e;
    return;
  }
  let n = 0, s;
  for (; n < r; )
    s = n + t, yield e.slice(n, s), n = s;
}, vs = async function* (e, t) {
  for await (const r of Is(e))
    yield* Cs(r, t);
}, Is = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: n } = await t.read();
      if (r)
        break;
      yield n;
    }
  } finally {
    await t.cancel();
  }
}, It = (e, t, r, n) => {
  const s = vs(e, t);
  let o = 0, a, i = (c) => {
    a || (a = !0, n && n(c));
  };
  return new ReadableStream(
    {
      async pull(c) {
        try {
          const { done: d, value: u } = await s.next();
          if (d) {
            i(), c.close();
            return;
          }
          let l = u.byteLength;
          if (r) {
            let g = o += l;
            r(g);
          }
          c.enqueue(new Uint8Array(u));
        } catch (d) {
          throw i(d), d;
        }
      },
      cancel(c) {
        return i(c), s.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, Ot = 64 * 1024, { isFunction: Te } = f, Os = (({ Request: e, Response: t }) => ({
  Request: e,
  Response: t
}))(f.global), { ReadableStream: Pt, TextEncoder: xt } = f.global, _t = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, Ps = (e) => {
  e = f.merge.call(
    {
      skipUndefined: !0
    },
    Os,
    e
  );
  const { fetch: t, Request: r, Response: n } = e, s = t ? Te(t) : typeof fetch == "function", o = Te(r), a = Te(n);
  if (!s)
    return !1;
  const i = s && Te(Pt), c = s && (typeof xt == "function" ? /* @__PURE__ */ ((p) => (m) => p.encode(m))(new xt()) : async (p) => new Uint8Array(await new r(p).arrayBuffer())), d = o && i && _t(() => {
    let p = !1;
    const m = new r(M.origin, {
      body: new Pt(),
      method: "POST",
      get duplex() {
        return p = !0, "half";
      }
    }).headers.has("Content-Type");
    return p && !m;
  }), u = a && i && _t(() => f.isReadableStream(new n("").body)), l = {
    stream: u && ((p) => p.body)
  };
  s && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((p) => {
    !l[p] && (l[p] = (m, h) => {
      let S = m && m[p];
      if (S)
        return S.call(m);
      throw new E(
        `Response type '${p}' is not supported`,
        E.ERR_NOT_SUPPORT,
        h
      );
    });
  });
  const g = async (p) => {
    if (p == null)
      return 0;
    if (f.isBlob(p))
      return p.size;
    if (f.isSpecCompliantForm(p))
      return (await new r(M.origin, {
        method: "POST",
        body: p
      }).arrayBuffer()).byteLength;
    if (f.isArrayBufferView(p) || f.isArrayBuffer(p))
      return p.byteLength;
    if (f.isURLSearchParams(p) && (p = p + ""), f.isString(p))
      return (await c(p)).byteLength;
  }, w = async (p, m) => {
    const h = f.toFiniteNumber(p.getContentLength());
    return h ?? g(m);
  };
  return async (p) => {
    let {
      url: m,
      method: h,
      data: S,
      signal: v,
      cancelToken: O,
      timeout: P,
      onDownloadProgress: A,
      onUploadProgress: C,
      responseType: T,
      headers: L,
      withCredentials: q = "same-origin",
      fetchOptions: U
    } = hr(p), B = t || fetch;
    T = T ? (T + "").toLowerCase() : "text";
    let $ = As(
      [v, O && O.toAbortSignal()],
      P
    ), R = null;
    const b = $ && $.unsubscribe && (() => {
      $.unsubscribe();
    });
    let x;
    try {
      if (C && d && h !== "get" && h !== "head" && (x = await w(L, S)) !== 0) {
        let te = new r(m, {
          method: "POST",
          body: S,
          duplex: "half"
        }), ie;
        if (f.isFormData(S) && (ie = te.headers.get("content-type")) && L.setContentType(ie), te.body) {
          const [Ve, Ee] = At(
            x,
            Pe(Ct(C))
          );
          S = It(te.body, Ot, Ve, Ee);
        }
      }
      f.isString(q) || (q = q ? "include" : "omit");
      const _ = o && "credentials" in r.prototype, z = {
        ...U,
        signal: $,
        method: h.toUpperCase(),
        headers: L.normalize().toJSON(),
        body: S,
        duplex: "half",
        credentials: _ ? q : void 0
      };
      R = o && new r(m, z);
      let H = await (o ? B(R, U) : B(m, z));
      const V = u && (T === "stream" || T === "response");
      if (u && (A || V && b)) {
        const te = {};
        ["status", "statusText", "headers"].forEach((gt) => {
          te[gt] = H[gt];
        });
        const ie = f.toFiniteNumber(H.headers.get("content-length")), [Ve, Ee] = A && At(
          ie,
          Pe(Ct(A), !0)
        ) || [];
        H = new n(
          It(H.body, Ot, Ve, () => {
            Ee && Ee(), b && b();
          }),
          te
        );
      }
      T = T || "text";
      let Re = await l[f.findKey(l, T) || "text"](
        H,
        p
      );
      return !V && b && b(), await new Promise((te, ie) => {
        fr(te, ie, {
          data: Re,
          headers: K.from(H.headers),
          status: H.status,
          statusText: H.statusText,
          config: p,
          request: R
        });
      });
    } catch (_) {
      throw b && b(), _ && _.name === "TypeError" && /Load failed|fetch/i.test(_.message) ? Object.assign(
        new E(
          "Network Error",
          E.ERR_NETWORK,
          p,
          R,
          _ && _.response
        ),
        {
          cause: _.cause || _
        }
      ) : E.from(_, _ && _.code, p, R, _ && _.response);
    }
  };
}, xs = /* @__PURE__ */ new Map(), mr = (e) => {
  let t = e && e.env || {};
  const { fetch: r, Request: n, Response: s } = t, o = [n, s, r];
  let a = o.length, i = a, c, d, u = xs;
  for (; i--; )
    c = o[i], d = u.get(c), d === void 0 && u.set(c, d = i ? /* @__PURE__ */ new Map() : Ps(t)), u = d;
  return d;
};
mr();
const dt = {
  http: Wn,
  xhr: Ts,
  fetch: {
    get: mr
  }
};
f.forEach(dt, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Lt = (e) => `- ${e}`, _s = (e) => f.isFunction(e) || e === null || e === !1;
function Ls(e, t) {
  e = f.isArray(e) ? e : [e];
  const { length: r } = e;
  let n, s;
  const o = {};
  for (let a = 0; a < r; a++) {
    n = e[a];
    let i;
    if (s = n, !_s(n) && (s = dt[(i = String(n)).toLowerCase()], s === void 0))
      throw new E(`Unknown adapter '${i}'`);
    if (s && (f.isFunction(s) || (s = s.get(t))))
      break;
    o[i || "#" + a] = s;
  }
  if (!s) {
    const a = Object.entries(o).map(
      ([c, d]) => `adapter ${c} ` + (d === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let i = r ? a.length > 1 ? `since :
` + a.map(Lt).join(`
`) : " " + Lt(a[0]) : "as no adapter specified";
    throw new E(
      "There is no suitable adapter to dispatch the request " + i,
      "ERR_NOT_SUPPORT"
    );
  }
  return s;
}
const yr = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: Ls,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: dt
};
function Ye(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Se(null, e);
}
function Nt(e) {
  return Ye(e), e.headers = K.from(e.headers), e.data = Ke.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), yr.getAdapter(e.adapter || be.adapter, e)(e).then(
    function(n) {
      return Ye(e), n.data = Ke.call(e, e.transformResponse, n), n.headers = K.from(n.headers), n;
    },
    function(n) {
      return dr(n) || (Ye(e), n && n.response && (n.response.data = Ke.call(
        e,
        e.transformResponse,
        n.response
      ), n.response.headers = K.from(n.response.headers))), Promise.reject(n);
    }
  );
}
const gr = "1.13.6", Be = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Be[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const qt = {};
Be.transitional = function(t, r, n) {
  function s(o, a) {
    return "[Axios v" + gr + "] Transitional option '" + o + "'" + a + (n ? ". " + n : "");
  }
  return (o, a, i) => {
    if (t === !1)
      throw new E(
        s(a, " has been removed" + (r ? " in " + r : "")),
        E.ERR_DEPRECATED
      );
    return r && !qt[a] && (qt[a] = !0, console.warn(
      s(
        a,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(o, a, i) : !0;
  };
};
Be.spelling = function(t) {
  return (r, n) => (console.warn(`${n} is likely a misspelling of ${t}`), !0);
};
function Ns(e, t, r) {
  if (typeof e != "object")
    throw new E("options must be an object", E.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let s = n.length;
  for (; s-- > 0; ) {
    const o = n[s], a = t[o];
    if (a) {
      const i = e[o], c = i === void 0 || a(i, o, e);
      if (c !== !0)
        throw new E(
          "option " + o + " must be " + c,
          E.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (r !== !0)
      throw new E("Unknown option " + o, E.ERR_BAD_OPTION);
  }
}
const Ie = {
  assertOptions: Ns,
  validators: Be
}, Y = Ie.validators;
let se = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new Et(),
      response: new Et()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, r) {
    try {
      return await this._request(t, r);
    } catch (n) {
      if (n instanceof Error) {
        let s = {};
        Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
        const o = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? o && !String(n.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + o) : n.stack = o;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(t, r) {
    typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = oe(this.defaults, r);
    const { transitional: n, paramsSerializer: s, headers: o } = r;
    n !== void 0 && Ie.assertOptions(
      n,
      {
        silentJSONParsing: Y.transitional(Y.boolean),
        forcedJSONParsing: Y.transitional(Y.boolean),
        clarifyTimeoutError: Y.transitional(Y.boolean),
        legacyInterceptorReqResOrdering: Y.transitional(Y.boolean)
      },
      !1
    ), s != null && (f.isFunction(s) ? r.paramsSerializer = {
      serialize: s
    } : Ie.assertOptions(
      s,
      {
        encode: Y.function,
        serialize: Y.function
      },
      !0
    )), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), Ie.assertOptions(
      r,
      {
        baseUrl: Y.spelling("baseURL"),
        withXsrfToken: Y.spelling("withXSRFToken")
      },
      !0
    ), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let a = o && f.merge(o.common, o[r.method]);
    o && f.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (p) => {
      delete o[p];
    }), r.headers = K.concat(a, o);
    const i = [];
    let c = !0;
    this.interceptors.request.forEach(function(m) {
      if (typeof m.runWhen == "function" && m.runWhen(r) === !1)
        return;
      c = c && m.synchronous;
      const h = r.transitional || ut;
      h && h.legacyInterceptorReqResOrdering ? i.unshift(m.fulfilled, m.rejected) : i.push(m.fulfilled, m.rejected);
    });
    const d = [];
    this.interceptors.response.forEach(function(m) {
      d.push(m.fulfilled, m.rejected);
    });
    let u, l = 0, g;
    if (!c) {
      const p = [Nt.bind(this), void 0];
      for (p.unshift(...i), p.push(...d), g = p.length, u = Promise.resolve(r); l < g; )
        u = u.then(p[l++], p[l++]);
      return u;
    }
    g = i.length;
    let w = r;
    for (; l < g; ) {
      const p = i[l++], m = i[l++];
      try {
        w = p(w);
      } catch (h) {
        m.call(this, h);
        break;
      }
    }
    try {
      u = Nt.call(this, w);
    } catch (p) {
      return Promise.reject(p);
    }
    for (l = 0, g = d.length; l < g; )
      u = u.then(d[l++], d[l++]);
    return u;
  }
  getUri(t) {
    t = oe(this.defaults, t);
    const r = pr(t.baseURL, t.url, t.allowAbsoluteUrls);
    return ur(r, t.params, t.paramsSerializer);
  }
};
f.forEach(["delete", "get", "head", "options"], function(t) {
  se.prototype[t] = function(r, n) {
    return this.request(
      oe(n || {}, {
        method: t,
        url: r,
        data: (n || {}).data
      })
    );
  };
});
f.forEach(["post", "put", "patch"], function(t) {
  function r(n) {
    return function(o, a, i) {
      return this.request(
        oe(i || {}, {
          method: t,
          headers: n ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: o,
          data: a
        })
      );
    };
  }
  se.prototype[t] = r(), se.prototype[t + "Form"] = r(!0);
});
let qs = class br {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const n = this;
    this.promise.then((s) => {
      if (!n._listeners) return;
      let o = n._listeners.length;
      for (; o-- > 0; )
        n._listeners[o](s);
      n._listeners = null;
    }), this.promise.then = (s) => {
      let o;
      const a = new Promise((i) => {
        n.subscribe(i), o = i;
      }).then(s);
      return a.cancel = function() {
        n.unsubscribe(o);
      }, a;
    }, t(function(o, a, i) {
      n.reason || (n.reason = new Se(o, a, i), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), r = (n) => {
      t.abort(n);
    };
    return this.subscribe(r), t.signal.unsubscribe = () => this.unsubscribe(r), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new br(function(s) {
        t = s;
      }),
      cancel: t
    };
  }
};
function js(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function Us(e) {
  return f.isObject(e) && e.isAxiosError === !0;
}
const rt = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(rt).forEach(([e, t]) => {
  rt[t] = e;
});
function Sr(e) {
  const t = new se(e), r = Xt(se.prototype.request, t);
  return f.extend(r, se.prototype, t, { allOwnKeys: !0 }), f.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(s) {
    return Sr(oe(e, s));
  }, r;
}
const j = Sr(be);
j.Axios = se;
j.CanceledError = Se;
j.CancelToken = qs;
j.isCancel = dr;
j.VERSION = gr;
j.toFormData = De;
j.AxiosError = E;
j.Cancel = j.CanceledError;
j.all = function(t) {
  return Promise.all(t);
};
j.spread = js;
j.isAxiosError = Us;
j.mergeConfig = oe;
j.AxiosHeaders = K;
j.formToJSON = (e) => lr(f.isHTMLForm(e) ? new FormData(e) : e);
j.getAdapter = yr.getAdapter;
j.HttpStatusCode = rt;
j.default = j;
const {
  Axios: li,
  AxiosError: di,
  CanceledError: fi,
  isCancel: pi,
  CancelToken: hi,
  VERSION: mi,
  all: yi,
  Cancel: gi,
  isAxiosError: bi,
  spread: Si,
  toFormData: wi,
  AxiosHeaders: Ri,
  HttpStatusCode: Ei,
  formToJSON: Ti,
  getAdapter: Ai,
  mergeConfig: Ci
} = j;
function ks({
  onRequest: e,
  onSseError: t,
  onSseEvent: r,
  responseTransformer: n,
  responseValidator: s,
  sseDefaultRetryDelay: o,
  sseMaxRetryAttempts: a,
  sseMaxRetryDelay: i,
  sseSleepFn: c,
  url: d,
  ...u
}) {
  let l;
  const g = c ?? ((m) => new Promise((h) => setTimeout(h, m)));
  return { stream: async function* () {
    let m = o ?? 3e3, h = 0;
    const S = u.signal ?? new AbortController().signal;
    for (; !S.aborted; ) {
      h++;
      const v = u.headers instanceof Headers ? u.headers : new Headers(u.headers);
      l !== void 0 && v.set("Last-Event-ID", l);
      try {
        const O = {
          redirect: "follow",
          ...u,
          body: u.serializedBody,
          headers: v,
          signal: S
        };
        let P = new Request(d, O);
        e && (P = await e(d, O));
        const C = await (u.fetch ?? globalThis.fetch)(P);
        if (!C.ok) throw new Error(`SSE failed: ${C.status} ${C.statusText}`);
        if (!C.body) throw new Error("No body in SSE response");
        const T = C.body.pipeThrough(new TextDecoderStream()).getReader();
        let L = "";
        const q = () => {
          try {
            T.cancel();
          } catch {
          }
        };
        S.addEventListener("abort", q);
        try {
          for (; ; ) {
            const { done: U, value: B } = await T.read();
            if (U) break;
            L += B, L = L.replace(/\r\n?/g, `
`);
            const $ = L.split(`

`);
            L = $.pop() ?? "";
            for (const R of $) {
              const b = R.split(`
`), x = [];
              let _;
              for (const V of b)
                if (V.startsWith("data:"))
                  x.push(V.replace(/^data:\s*/, ""));
                else if (V.startsWith("event:"))
                  _ = V.replace(/^event:\s*/, "");
                else if (V.startsWith("id:"))
                  l = V.replace(/^id:\s*/, "");
                else if (V.startsWith("retry:")) {
                  const Re = Number.parseInt(V.replace(/^retry:\s*/, ""), 10);
                  Number.isNaN(Re) || (m = Re);
                }
              let z, H = !1;
              if (x.length) {
                const V = x.join(`
`);
                try {
                  z = JSON.parse(V), H = !0;
                } catch {
                  z = V;
                }
              }
              H && (s && await s(z), n && (z = await n(z))), r == null || r({
                data: z,
                event: _,
                id: l,
                retry: m
              }), x.length && (yield z);
            }
          }
        } finally {
          S.removeEventListener("abort", q), T.releaseLock();
        }
        break;
      } catch (O) {
        if (t == null || t(O), a !== void 0 && h >= a)
          break;
        const P = Math.min(m * 2 ** (h - 1), i ?? 3e4);
        await g(P);
      }
    }
  }() };
}
const Fs = (e) => {
  switch (e) {
    case "label":
      return ".";
    case "matrix":
      return ";";
    case "simple":
      return ",";
    default:
      return "&";
  }
}, Ds = (e) => {
  switch (e) {
    case "form":
      return ",";
    case "pipeDelimited":
      return "|";
    case "spaceDelimited":
      return "%20";
    default:
      return ",";
  }
}, Bs = (e) => {
  switch (e) {
    case "label":
      return ".";
    case "matrix":
      return ";";
    case "simple":
      return ",";
    default:
      return "&";
  }
}, wr = ({
  allowReserved: e,
  explode: t,
  name: r,
  style: n,
  value: s
}) => {
  if (!t) {
    const i = (e ? s : s.map((c) => encodeURIComponent(c))).join(Ds(n));
    switch (n) {
      case "label":
        return `.${i}`;
      case "matrix":
        return `;${r}=${i}`;
      case "simple":
        return i;
      default:
        return `${r}=${i}`;
    }
  }
  const o = Fs(n), a = s.map((i) => n === "label" || n === "simple" ? e ? i : encodeURIComponent(i) : $e({
    allowReserved: e,
    name: r,
    value: i
  })).join(o);
  return n === "label" || n === "matrix" ? o + a : a;
}, $e = ({
  allowReserved: e,
  name: t,
  value: r
}) => {
  if (r == null)
    return "";
  if (typeof r == "object")
    throw new Error(
      "Deeply-nested arrays/objects aren’t supported. Provide your own `querySerializer()` to handle these."
    );
  return `${t}=${e ? r : encodeURIComponent(r)}`;
}, Rr = ({
  allowReserved: e,
  explode: t,
  name: r,
  style: n,
  value: s,
  valueOnly: o
}) => {
  if (s instanceof Date)
    return o ? s.toISOString() : `${r}=${s.toISOString()}`;
  if (n !== "deepObject" && !t) {
    let c = [];
    Object.entries(s).forEach(([u, l]) => {
      c = [...c, u, e ? l : encodeURIComponent(l)];
    });
    const d = c.join(",");
    switch (n) {
      case "form":
        return `${r}=${d}`;
      case "label":
        return `.${d}`;
      case "matrix":
        return `;${r}=${d}`;
      default:
        return d;
    }
  }
  const a = Bs(n), i = Object.entries(s).map(
    ([c, d]) => $e({
      allowReserved: e,
      name: n === "deepObject" ? `${r}[${c}]` : c,
      value: d
    })
  ).join(a);
  return n === "label" || n === "matrix" ? a + i : i;
}, $s = /\{[^{}]+\}/g, Ms = ({ path: e, url: t }) => {
  let r = t;
  const n = t.match($s);
  if (n)
    for (const s of n) {
      let o = !1, a = s.substring(1, s.length - 1), i = "simple";
      a.endsWith("*") && (o = !0, a = a.substring(0, a.length - 1)), a.startsWith(".") ? (a = a.substring(1), i = "label") : a.startsWith(";") && (a = a.substring(1), i = "matrix");
      const c = e[a];
      if (c == null)
        continue;
      if (Array.isArray(c)) {
        r = r.replace(s, wr({ explode: o, name: a, style: i, value: c }));
        continue;
      }
      if (typeof c == "object") {
        r = r.replace(
          s,
          Rr({
            explode: o,
            name: a,
            style: i,
            value: c,
            valueOnly: !0
          })
        );
        continue;
      }
      if (i === "matrix") {
        r = r.replace(
          s,
          `;${$e({
            name: a,
            value: c
          })}`
        );
        continue;
      }
      const d = encodeURIComponent(
        i === "label" ? `.${c}` : c
      );
      r = r.replace(s, d);
    }
  return r;
}, zs = ({
  baseUrl: e,
  path: t,
  query: r,
  querySerializer: n,
  url: s
}) => {
  const o = s.startsWith("/") ? s : `/${s}`;
  let a = (e ?? "") + o;
  t && (a = Ms({ path: t, url: a }));
  let i = r ? n(r) : "";
  return i.startsWith("?") && (i = i.substring(1)), i && (a += `?${i}`), a;
};
function jt(e) {
  const t = e.body !== void 0;
  if (t && e.bodySerializer)
    return "serializedBody" in e ? e.serializedBody !== void 0 && e.serializedBody !== "" ? e.serializedBody : null : e.body !== "" ? e.body : null;
  if (t)
    return e.body;
}
const Gs = async (e, t) => {
  const r = typeof t == "function" ? await t(e) : t;
  if (r)
    return e.scheme === "bearer" ? `Bearer ${r}` : e.scheme === "basic" ? `Basic ${btoa(r)}` : r;
}, Hs = ({
  parameters: e = {},
  ...t
} = {}) => (n) => {
  const s = [];
  if (n && typeof n == "object")
    for (const o in n) {
      const a = n[o];
      if (a == null)
        continue;
      const i = e[o] || t;
      if (Array.isArray(a)) {
        const c = wr({
          allowReserved: i.allowReserved,
          explode: !0,
          name: o,
          style: "form",
          value: a,
          ...i.array
        });
        c && s.push(c);
      } else if (typeof a == "object") {
        const c = Rr({
          allowReserved: i.allowReserved,
          explode: !0,
          name: o,
          style: "deepObject",
          value: a,
          ...i.object
        });
        c && s.push(c);
      } else {
        const c = $e({
          allowReserved: i.allowReserved,
          name: o,
          value: a
        });
        c && s.push(c);
      }
    }
  return s.join("&");
}, Vs = (e, t) => {
  var r;
  return t ? t in e.headers || (r = e.query) != null && r[t] ? !0 : "Cookie" in e.headers && e.headers.Cookie && typeof e.headers.Cookie == "string" ? e.headers.Cookie.includes(`${t}=`) : !1 : !1;
};
async function Ws(e) {
  for (const t of e.security ?? []) {
    if (Vs(e, t.name))
      continue;
    const r = await Gs(t, e.auth);
    if (!r)
      continue;
    const n = t.name ?? "Authorization";
    switch (t.in) {
      case "query":
        e.query || (e.query = {}), e.query[n] = r;
        break;
      case "cookie": {
        const s = `${n}=${r}`;
        "Cookie" in e.headers && e.headers.Cookie ? e.headers.Cookie = `${e.headers.Cookie}; ${s}` : e.headers.Cookie = s;
        break;
      }
      case "header":
      default:
        e.headers[n] = r;
        break;
    }
  }
}
const Ut = (e) => {
  var n, s;
  const t = (s = (n = e.axios) == null ? void 0 : n.defaults) == null ? void 0 : s.baseURL, r = e.baseURL && typeof e.baseURL == "string" ? e.baseURL : t;
  return zs({
    baseUrl: r,
    path: e.path,
    // let `paramsSerializer()` handle query params if it exists
    query: e.paramsSerializer ? void 0 : e.query,
    querySerializer: typeof e.querySerializer == "function" ? e.querySerializer : Hs(e.querySerializer),
    url: e.url
  });
}, kt = (e, t) => {
  const r = { ...e, ...t };
  return r.headers = nt(e.headers, t.headers), r;
}, Js = [
  "common",
  "delete",
  "get",
  "head",
  "patch",
  "post",
  "put"
], nt = (...e) => {
  const t = {};
  for (const r of e) {
    if (!r || typeof r != "object")
      continue;
    const n = Object.entries(r);
    for (const [s, o] of n)
      if (Js.includes(s) && typeof o == "object")
        t[s] = {
          ...t[s],
          ...o
        };
      else if (o === null)
        delete t[s];
      else if (Array.isArray(o))
        for (const a of o)
          t[s] = [...t[s] ?? [], a];
      else o !== void 0 && (t[s] = typeof o == "object" ? JSON.stringify(o) : o);
  }
  return t;
}, Er = (e = {}) => ({
  ...e
}), Ks = (e = {}) => {
  let t = kt(Er(), e), r;
  if (t.axios && !("Axios" in t.axios))
    r = t.axios;
  else {
    const { auth: u, ...l } = t;
    r = j.create(l);
  }
  const n = () => ({ ...t }), s = (u) => (t = kt(t, u), r.defaults = {
    ...r.defaults,
    ...t,
    // @ts-expect-error
    headers: nt(r.defaults.headers, t.headers)
  }, n()), o = async (u) => {
    const l = {
      ...t,
      ...u,
      axios: u.axios ?? t.axios ?? r,
      headers: nt(t.headers, u.headers)
    };
    l.security && await Ws(l), l.requestValidator && await l.requestValidator(l), l.body !== void 0 && l.bodySerializer && (l.body = l.bodySerializer(l.body));
    const g = Ut(l);
    return { opts: l, url: g };
  }, a = async (u) => {
    var w;
    const { opts: l, url: g } = await o(u);
    try {
      const p = l.axios, { auth: m, ...h } = l, S = await p({
        ...h,
        baseURL: "",
        // the baseURL is already included in `url`
        data: jt(l),
        headers: l.headers,
        // let `paramsSerializer()` handle query params if it exists
        params: l.paramsSerializer ? l.query : void 0,
        url: g
      });
      let { data: v } = S;
      return l.responseType === "json" && (l.responseValidator && await l.responseValidator(v), l.responseTransformer && (v = await l.responseTransformer(v))), {
        ...S,
        data: v ?? {}
      };
    } catch (p) {
      const m = p;
      if (l.throwOnError)
        throw m;
      return m.error = ((w = m.response) == null ? void 0 : w.data) ?? {}, m;
    }
  }, i = (u) => (l) => a({ ...l, method: u }), c = (u) => async (l) => {
    const { opts: g, url: w } = await o(l);
    return ks({
      ...g,
      body: g.body,
      headers: g.headers,
      method: u,
      serializedBody: jt(g),
      // @ts-expect-error
      signal: g.signal,
      url: w
    });
  };
  return {
    buildUrl: (u) => Ut({ axios: r, ...t, ...u }),
    connect: i("CONNECT"),
    delete: i("DELETE"),
    get: i("GET"),
    getConfig: n,
    head: i("HEAD"),
    instance: r,
    options: i("OPTIONS"),
    patch: i("PATCH"),
    post: i("POST"),
    put: i("PUT"),
    request: a,
    setConfig: s,
    sse: {
      connect: c("CONNECT"),
      delete: c("DELETE"),
      get: c("GET"),
      head: c("HEAD"),
      options: c("OPTIONS"),
      patch: c("PATCH"),
      post: c("POST"),
      put: c("PUT"),
      trace: c("TRACE")
    },
    trace: i("TRACE")
  };
}, y = Ks(Er({ baseURL: "/_api", throwOnError: !0 })), Ft = "MFA_OR_AAL_2_REQUIRED", Ys = "insufficient_user_authentication", vi = "mod-mf", Ii = "mod-pr";
function Qs(e) {
  if (!e) return null;
  const t = /^Bearer\s+(.+)/i.exec(e);
  if (!t) return null;
  const r = Xs(t[1]);
  if (r.error !== Ys) return null;
  const n = { source: "header" };
  if (r.acr_values && (n.acrValues = r.acr_values), r.max_age) {
    const s = Number(r.max_age);
    Number.isFinite(s) && s >= 0 && (n.maxAge = s);
  }
  return n;
}
function Xs(e) {
  const t = {}, r = /([a-zA-Z_][a-zA-Z0-9_]*)=(?:"((?:[^"\\]|\\.)*)"|([^\s,]*))/g;
  let n;
  for (; (n = r.exec(e)) !== null; ) {
    const s = n[1], o = n[2] !== void 0 ? n[2].replace(/\\(.)/g, "$1") : n[3];
    t[s] = o;
  }
  return t;
}
function Zs(e) {
  if (typeof e != "object" || e === null) return !1;
  const r = e.error;
  if (typeof r != "object" || r === null) return !1;
  const n = r;
  if (n.code === Ft) return !0;
  const s = n.error;
  return typeof s == "object" && s !== null ? s.code === Ft : !1;
}
const xe = "clique.stepUp.pendingRequest", ea = 300 * 1e3, ta = /* @__PURE__ */ new Set(["post", "put", "patch", "delete"]);
function ra(e) {
  if (!e || typeof e != "object") return;
  const t = e, r = typeof t.get == "function" ? t.get("Content-Type") : t["Content-Type"] ?? t["content-type"];
  return typeof r == "string" ? r : void 0;
}
function na(e) {
  if (!(e != null && e.url) || !e.method) return;
  const t = e.method.toLowerCase();
  if (ta.has(t))
    return {
      method: t,
      url: e.url,
      data: e.data,
      params: e.params,
      contentType: ra(e.headers)
    };
}
function sa(e) {
  try {
    const t = { ...e, savedAt: Date.now() };
    sessionStorage.setItem(xe, JSON.stringify(t));
  } catch {
  }
}
function aa() {
  try {
    const e = sessionStorage.getItem(xe);
    if (!e) return null;
    sessionStorage.removeItem(xe);
    const t = JSON.parse(e);
    if (typeof t.savedAt != "number" || Date.now() - t.savedAt > ea)
      return null;
    const { savedAt: r, ...n } = t;
    return !n.url || !n.method ? null : n;
  } catch {
    return null;
  }
}
function Dt() {
  try {
    sessionStorage.removeItem(xe);
  } catch {
  }
}
function Tr(e) {
  return {
    method: e.method,
    url: e.url,
    data: e.data,
    params: e.params,
    headers: e.contentType ? { "Content-Type": e.contentType } : void 0
  };
}
async function oa(e, t = {}) {
  var r, n, s;
  try {
    return await e(), await ((r = t.queryClient) == null ? void 0 : r.invalidateQueries()), (n = t.notify) == null || n.call(t, {
      severity: "success",
      summary: "Action Completed",
      detail: "Your previous action finished after verification."
    }), !0;
  } catch (o) {
    return console.error("Failed to resume action after step-up", o), (s = t.notify) == null || s.call(t, {
      severity: "error",
      summary: "Action Not Completed",
      detail: "Your previous action could not be completed. Please try again."
    }), !1;
  }
}
function ae(e) {
  if (typeof e == "object" && e !== null)
    return e;
}
function re(e) {
  if (typeof e != "string") return;
  const t = e.trim();
  return t.length > 0 ? t : void 0;
}
function ia(e) {
  return {
    message: re(e.message),
    code: re(e.code),
    name: re(e.name)
  };
}
function ft(e) {
  if (typeof e == "string")
    return { message: re(e) };
  const t = ae(e);
  if (!t) return {};
  const r = re(t.error_description), n = re(t.message), s = t.error;
  if (typeof s == "string")
    return {
      message: r ?? re(s),
      code: re(s)
    };
  const o = ae(s);
  if (o) {
    const a = ae(o.error), i = ia(a ?? o);
    return {
      message: i.message ?? r ?? n,
      code: i.code,
      name: i.name
    };
  }
  return {
    message: r ?? n
  };
}
function Ar(e) {
  const t = ae(e);
  if (!t) return;
  const r = ae(t.response);
  if (r && typeof r.status == "number")
    return r.status;
}
function Cr(e) {
  const t = ae(e), r = ae(t == null ? void 0 : t.response);
  return r == null ? void 0 : r.data;
}
function Oi(e) {
  return ft(Cr(e)).message;
}
const Bt = "UserAlreadyAssigned", ca = /already assigned/i;
function Pi(e) {
  if (Ar(e) !== 422) return !1;
  const r = ft(Cr(e));
  return r.name === Bt || r.code === Bt ? !0 : ca.test(r.message ?? "");
}
const ua = /required scope:\s*(.+)$/i, la = /^(access denied|authorization required|forbidden|insufficient permissions)\.?$/i;
function da(e) {
  const t = ua.exec(e);
  if (t)
    return t[1].replace(/[.\s]+$/, "").trim() || void 0;
}
const Ae = "You don’t have permission to perform this action.";
function fa(e) {
  const t = e == null ? void 0 : e.message;
  if (!t) return Ae;
  const r = da(t);
  return r ? `${Ae} Required scope: ${r}` : la.test(t) ? Ae : `${Ae} ${t}`;
}
let st = null;
function pa({
  baseURL: e,
  getAccessToken: t,
  onUnauthorized: r,
  onStepUpRequired: n,
  onForbidden: s
}) {
  const o = j.create({ baseURL: e });
  return o.interceptors.request.use((a) => {
    const i = t();
    return i && (a.headers.Authorization = `Bearer ${i}`), a;
  }), o.interceptors.response.use(
    (a) => a,
    (a) => {
      var i, c, d, u, l;
      if (j.isAxiosError(a) && (((i = a.response) == null ? void 0 : i.status) === 401 || ((c = a.response) == null ? void 0 : c.status) === 403)) {
        const g = typeof ((d = a.response.headers) == null ? void 0 : d["www-authenticate"]) == "string" ? a.response.headers["www-authenticate"] : void 0, w = Qs(g), p = a.config ? na(a.config) : void 0, m = (h) => {
          const S = n == null ? void 0 : n(h, p);
          return S && typeof S.then == "function" ? Promise.resolve(S).then(
            (v) => v || Promise.reject(a)
          ) : Promise.reject(a);
        };
        if (w)
          return console.warn("Auth API returned RFC 9470 step-up challenge — MFA required"), m(w);
        if (Zs(a.response.data))
          return console.warn("Auth API returned step-up auth challenge — MFA required"), m({ source: "legacy" });
        if (a.response.status === 401)
          console.warn("Auth API returned 401 — token may be expired"), r == null || r();
        else {
          const h = ha(a);
          console.warn("Auth API returned 403 — access denied", h);
          const S = (l = (u = a.config) == null ? void 0 : u.method) == null ? void 0 : l.toLowerCase();
          s == null || s(h, S ? { method: S } : void 0);
        }
      }
      return Promise.reject(a);
    }
  ), st = o, y.setConfig({ axios: o, baseURL: e }), o;
}
function ha(e) {
  var t;
  return ft((t = e.response) == null ? void 0 : t.data);
}
function vr() {
  if (!st)
    throw new Error("API client not initialized. Wrap your app in <ApiClientProvider>.");
  return st;
}
const ma = {
  expiring: {
    header: "Session Expiring Soon",
    icon: "pi pi-clock",
    iconColor: "text-[var(--clique-warning)]",
    message: "Your session is about to expire due to inactivity.",
    detail: "Select continue to stay signed in.",
    buttonLabel: "Continue Session",
    buttonIcon: "pi pi-refresh",
    action: "continue"
  },
  expired: {
    header: "Session Expired",
    icon: "pi pi-clock",
    iconColor: "text-[var(--clique-warning)]",
    message: "Your session has expired due to inactivity.",
    detail: "Please log in again to continue where you left off.",
    buttonLabel: "Log In",
    buttonIcon: "pi pi-sign-in",
    action: "login"
  },
  "step-up": {
    header: "Additional Verification Required",
    icon: "pi pi-shield",
    iconColor: "text-[var(--clique-primary)]",
    message: "This action requires multi-factor authentication.",
    detail: "You'll be redirected to verify your identity.",
    buttonLabel: "Continue to Verify",
    buttonIcon: "pi pi-lock",
    action: "continue"
  }
};
function Ir({
  visible: e,
  variant: t,
  onContinue: r,
  onLogin: n,
  className: s,
  style: o,
  pt: a
}) {
  const i = ma[t], c = i.action === "continue" ? r : n;
  return /* @__PURE__ */ I(
    en,
    {
      visible: e,
      onHide: () => {
      },
      closable: !1,
      draggable: !1,
      resizable: !1,
      modal: !0,
      header: i.header,
      className: s,
      style: { width: "28rem", ...o },
      pt: a,
      children: /* @__PURE__ */ he("div", { className: "flex flex-col items-center text-center py-2", children: [
        /* @__PURE__ */ I("i", { className: `${i.icon} text-5xl ${i.iconColor} mb-4`, "aria-hidden": "true" }),
        /* @__PURE__ */ I("p", { className: "text-[var(--clique-fg)] mb-2", children: i.message }),
        /* @__PURE__ */ I("p", { className: "text-[var(--clique-fg-secondary)] text-sm mb-6", children: i.detail }),
        /* @__PURE__ */ I(
          tn,
          {
            label: i.buttonLabel,
            icon: i.buttonIcon,
            onClick: c,
            className: "w-full"
          }
        )
      ] })
    }
  );
}
function ya(e = window.location.search) {
  return new URLSearchParams(e).get("connection") || void 0;
}
function xi(e) {
  const t = new URLSearchParams(e);
  t.delete("connection");
  const r = t.toString();
  return r ? `?${r}` : "";
}
const ga = [
  "code",
  "error",
  "error_description",
  "error_uri",
  "iss",
  "session_state",
  "state"
];
function ba(e) {
  const t = new URLSearchParams(e), r = t.has("code") || t.has("error");
  if (t.delete("connection"), r)
    for (const s of ga)
      t.delete(s);
  const n = t.toString();
  return n ? `?${n}` : "";
}
function Or(e) {
  if (!e || !e.startsWith("/") || e.startsWith("//"))
    return "/";
  try {
    const t = new URL(e, "https://clique.invalid");
    return `${t.pathname}${ba(t.search)}${t.hash}`;
  } catch {
    return "/";
  }
}
function Pr(e = window.location.pathname, t = window.location.search) {
  return Or(e + t);
}
function Sa(e, t) {
  return {
    ...e ? { extraQueryParams: { connection: e } } : {},
    state: { returnTo: Or(t ?? Pr()) }
  };
}
function _i(e, t = {}) {
  const r = t.connection ?? ya();
  return e.signinRedirect(Sa(r, t.returnTo));
}
const pt = G(null), wa = 15, $t = [
  "mousemove",
  "mousedown",
  "keydown",
  "scroll",
  "touchstart"
];
function Qe(e) {
  const t = e == null ? void 0 : e.refresh_token;
  return typeof t != "string" || t.length === 0 ? null : t;
}
function Li({
  children: e,
  idleTimeoutMs: t,
  nearExpiryWindowMs: r,
  enableDiagnostics: n = !1
}) {
  var O, P;
  const s = rn(), [o, a] = ee(null), i = W(!1), c = W(Date.now()), d = W(null), u = W(null), l = W(null), g = D(() => {
    d.current !== null && (window.clearTimeout(d.current), d.current = null);
  }, []), w = D(() => {
    var T;
    g();
    const A = (T = s.user) == null ? void 0 : T.expires_at;
    if (!A) {
      a("expired");
      return;
    }
    const C = A * 1e3 - Date.now();
    if (C <= 0) {
      a("expired");
      return;
    }
    d.current = window.setTimeout(() => {
      a("expired");
    }, C);
  }, [(O = s.user) == null ? void 0 : O.expires_at, g]), p = D(async () => {
    if (u.current)
      return u.current;
    const A = (async () => {
      i.current = !0;
      const C = Qe(s.user);
      try {
        const T = await s.signinSilent({
          silentRequestTimeoutInSeconds: wa
        });
        if (!T)
          return console.warn("Silent token refresh returned no user"), !1;
        if (g(), a(null), c.current = Date.now(), n) {
          const L = Qe(T);
          C || console.warn(
            "Session diagnostics: silent refresh completed but no refresh token was present before renewal."
          ), L ? console.info(
            C && C !== L ? "Session diagnostics: refresh token rotated after silent renewal (expected rotation behavior)." : "Session diagnostics: silent renewal succeeded and refresh token is present."
          ) : console.warn(
            "Session diagnostics: silent refresh completed but no refresh token was returned after renewal."
          );
        }
        return !0;
      } catch (T) {
        return console.warn("Silent token refresh failed", T), !1;
      } finally {
        i.current = !1, u.current = null;
      }
    })();
    return u.current = A, A;
  }, [s, g, n]), m = D(() => {
    g(), a("expired");
  }, [g]), h = D(async () => {
    await p() || a("expired");
  }, [p]), S = D(() => {
    const A = Pr();
    s.signinRedirect({ state: { returnTo: A } }).catch((C) => {
      console.warn("Redirect login failed", C);
    });
  }, [s]);
  Q(() => {
    const A = () => {
      c.current = Date.now();
    };
    for (const T of $t)
      window.addEventListener(T, A);
    const C = () => {
      document.visibilityState === "visible" && A();
    };
    return document.addEventListener("visibilitychange", C), () => {
      for (const T of $t)
        window.removeEventListener(T, A);
      document.removeEventListener("visibilitychange", C);
    };
  }, []), Q(() => () => {
    g();
  }, [g]), Q(() => {
    s.isAuthenticated || (g(), a(null));
  }, [s.isAuthenticated, g]), Q(() => {
    if (!n)
      return;
    if (!s.isAuthenticated) {
      l.current = null;
      return;
    }
    const A = Qe(s.user);
    if (!A) {
      console.warn(
        "Session diagnostics: authenticated user does not have a refresh token. Verify this client is configured by the IdP to issue refresh tokens."
      ), l.current = null;
      return;
    }
    l.current ? l.current !== A && console.info("Session diagnostics: refresh token rotation detected on updated user session.") : console.info(
      "Session diagnostics: refresh token detected for authenticated session. Silent refresh will use token endpoint grants."
    ), l.current = A;
  }, [s.isAuthenticated, s.user, n]), Q(() => {
    const A = () => {
      if (Date.now() - c.current >= t) {
        a("expiring"), w();
        return;
      }
      p().then((L) => {
        var q;
        if (!L) {
          if ((((q = s.user) == null ? void 0 : q.expires_at) ?? 0) * 1e3 - Date.now() > 0) {
            a("expiring"), w();
            return;
          }
          a("expired");
        }
      });
    }, C = () => {
      a("expired"), g();
    };
    return s.events.addAccessTokenExpiring(A), s.events.addAccessTokenExpired(C), () => {
      s.events.removeAccessTokenExpiring(A), s.events.removeAccessTokenExpired(C);
    };
  }, [
    s.events,
    (P = s.user) == null ? void 0 : P.expires_at,
    p,
    g,
    t,
    r,
    w
  ]);
  const v = F(
    () => ({ isSilentRefreshInProgressRef: i, markSessionExpired: m }),
    [m]
  );
  return /* @__PURE__ */ he(pt.Provider, { value: v, children: [
    e,
    /* @__PURE__ */ I(
      Ir,
      {
        visible: o !== null,
        variant: o ?? "expired",
        onContinue: h,
        onLogin: S
      }
    )
  ] });
}
function Ni() {
  const e = k(pt);
  if (!e)
    throw new Error("useSessionManagement must be used within a <SessionManagementProvider>.");
  return e;
}
function Ra() {
  return k(pt);
}
const ht = G(null), Ea = 4e3;
function Ta({ children: e }) {
  const t = W(null), r = W(null), s = { notify: D((o) => {
    var d;
    const a = `${o.severity}|${o.summary}|${o.detail ?? ""}`, i = Date.now(), c = r.current;
    c && c.key === a && i - c.at < Ea || (r.current = { key: a, at: i }, (d = t.current) == null || d.show({
      severity: o.severity,
      summary: o.summary,
      detail: o.detail,
      life: o.life ?? 5e3
    }));
  }, []) };
  return /* @__PURE__ */ he(ht.Provider, { value: s, children: [
    e,
    /* @__PURE__ */ I(nn, { ref: t })
  ] });
}
function qi() {
  const e = k(ht);
  if (!e)
    throw new Error("useNotifications must be used within a <NotificationProvider>.");
  return e;
}
function xr() {
  return k(ht);
}
const _r = G(null);
function Aa({
  baseURL: e,
  children: t,
  getAccessToken: r,
  onLoginRequired: n,
  onStepUpRequired: s,
  queryClient: o,
  suppressForbiddenToast: a = !1
}) {
  const i = Ra(), c = xr(), [d, u] = ee(null), l = W(null), g = W(null), w = W(null), p = W(null), m = D(() => {
    if (!(i != null && i.isSilentRefreshInProgressRef.current)) {
      if (c == null || c.notify({
        severity: "warn",
        summary: "Session Expired",
        detail: "Your session has expired. Please sign in again."
      }), i) {
        i.markSessionExpired();
        return;
      }
      l.current || (l.current = "expired", u("expired"));
    }
  }, [i, c]), h = D(
    (T, L) => {
      if (c == null || c.notify({
        severity: "warn",
        summary: "Additional Verification Required",
        detail: "This action requires additional authentication."
      }), !l.current)
        return g.current = T, w.current = L ?? null, l.current = "step-up", u("step-up"), new Promise((q) => {
          p.current = { resolve: q };
        });
    },
    [c]
  ), S = D(
    (T, L) => {
      var U;
      const q = (U = L == null ? void 0 : L.method) == null ? void 0 : U.toLowerCase();
      a !== "all" && (a === "gets" && q === "get" || c == null || c.notify({
        severity: "error",
        summary: "Access Denied",
        detail: fa(T),
        life: 8e3
      }));
    },
    [c, a]
  ), v = W(!1), O = D(() => {
    if (v.current) return;
    const T = g.current;
    if (!(s ?? n)) return;
    const q = w.current;
    q && sa(q), v.current = !0;
    const U = (R) => {
      var b;
      (b = p.current) == null || b.resolve(R), p.current = null;
    }, B = () => {
      l.current = null, u(null), g.current = null, w.current = null, v.current = !1;
    }, $ = (R) => {
      console.error("Step-up/login redirect failed", R), Dt(), c == null || c.notify({
        severity: "error",
        summary: "Redirect Failed",
        detail: "Could not start the verification process. Please try again."
      }), U(null), B();
    };
    try {
      const R = s ? s(T ?? { source: "legacy" }) : n == null ? void 0 : n();
      Promise.resolve(R).then(async (b) => {
        const x = b && typeof b == "object" && "access_token" in b && typeof b.access_token == "string" ? b.access_token : null;
        if (x) {
          if (Dt(), q) {
            try {
              const _ = Tr(q), z = await j.request({
                baseURL: e,
                ..._,
                headers: {
                  ..._.headers,
                  Authorization: `Bearer ${x}`
                }
              });
              await (o == null ? void 0 : o.invalidateQueries()), U(z), B();
            } catch (_) {
              console.error("Failed to resume action after step-up", _), c == null || c.notify({
                severity: "error",
                summary: "Action Not Completed",
                detail: "Your previous action could not be completed. Please try again."
              }), U(null), B();
            }
            return;
          }
          await (o == null ? void 0 : o.invalidateQueries()), c == null || c.notify({
            severity: "success",
            summary: "Verification Complete",
            detail: "Authentication was successful."
          }), U(null), B();
        }
      }, $);
    } catch (R) {
      $(R);
    }
  }, [s, n, c, e, o]), P = D(() => {
    if (n)
      try {
        const T = n();
        Promise.resolve(T).catch((L) => {
          console.error("Login redirect failed", L), c == null || c.notify({
            severity: "error",
            summary: "Redirect Failed",
            detail: "Could not start the sign-in process. Please try again."
          });
        });
      } catch (T) {
        console.error("Login redirect failed", T), c == null || c.notify({
          severity: "error",
          summary: "Redirect Failed",
          detail: "Could not start the sign-in process. Please try again."
        });
      }
  }, [n, c]), A = F(
    () => pa({
      baseURL: e,
      getAccessToken: r,
      onUnauthorized: m,
      onStepUpRequired: h,
      onForbidden: S
    }),
    [e, r, m, h, S]
  ), C = d === "step-up" || !i && d !== null;
  return /* @__PURE__ */ he(_r.Provider, { value: A, children: [
    t,
    C && d && n && /* @__PURE__ */ I(
      Ir,
      {
        visible: !0,
        variant: d,
        onContinue: d === "step-up" ? O : P,
        onLogin: P
      }
    )
  ] });
}
function Ca() {
  const e = k(_r);
  if (!e)
    throw new Error("useApiClient must be used within an <ApiClientProvider>.");
  return e;
}
const ji = (e) => (e.client ?? y).get({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/issuers/{id}",
  ...e
}), Ui = (e) => ((e == null ? void 0 : e.client) ?? y).get({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/issuers",
  ...e
}), va = (e) => ((e == null ? void 0 : e.client) ?? y).get({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/public-tenants",
  ...e
}), ki = (e) => (e.client ?? y).post({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/access-requests",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e.headers
  }
}), Fi = (e) => (e.client ?? y).get({
  querySerializer: { parameters: { where: { object: { style: "form" } } } },
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/access-roles/count",
  ...e
}), Di = (e) => (e.client ?? y).get({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/access-roles/{accessRoleId}/resource-server-permissions",
  ...e
}), Bi = (e) => (e.client ?? y).delete({
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/access-roles/{id}",
  ...e
}), $i = (e) => (e.client ?? y).get({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/access-roles/{id}",
  ...e
}), Mi = (e) => (e.client ?? y).patch({
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/access-roles/{id}",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e.headers
  }
}), zi = (e) => (e.client ?? y).get({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/access-roles",
  ...e
}), Gi = (e) => (e.client ?? y).post({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/access-roles",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e.headers
  }
}), Hi = (e) => (e.client ?? y).get({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/clients/{id}",
  ...e
}), Vi = (e) => (e.client ?? y).get({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/clients",
  ...e
}), Wi = (e) => (e.client ?? y).get({
  querySerializer: { parameters: { where: { object: { style: "form" } } } },
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/groups/count",
  ...e
}), Ji = (e) => (e.client ?? y).delete({
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/groups/{groupId}/access-roles/rel/{accessRoleId}",
  ...e
}), Ki = (e) => (e.client ?? y).put({
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/groups/{groupId}/access-roles/rel/{accessRoleId}",
  ...e
}), Yi = (e) => (e.client ?? y).get({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/groups/{groupId}/access-roles",
  ...e
}), Qi = (e) => (e.client ?? y).put({
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/groups/{groupId}/users/assign/bulk",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e.headers
  }
}), Xi = (e) => (e.client ?? y).get({
  querySerializer: { parameters: { where: { object: { style: "form" } } } },
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/groups/{groupId}/users/count",
  ...e
}), Zi = (e) => (e.client ?? y).delete({
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/groups/{groupId}/users/rel/{userId}",
  ...e
}), ec = (e) => (e.client ?? y).put({
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/groups/{groupId}/users/rel/{userId}",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e.headers
  }
}), tc = (e) => (e.client ?? y).put({
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/groups/{groupId}/users/{userId}/metadata",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e.headers
  }
}), rc = (e) => (e.client ?? y).put({
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/groups/{groupId}/users/{userId}/role-in-group",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e.headers
  }
}), nc = (e) => (e.client ?? y).get({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/groups/{groupId}/users",
  ...e
}), sc = (e) => (e.client ?? y).delete({
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/groups/{id}",
  ...e
}), ac = (e) => (e.client ?? y).get({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/groups/{id}",
  ...e
}), oc = (e) => (e.client ?? y).patch({
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/groups/{id}",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e.headers
  }
}), ic = (e) => (e.client ?? y).get({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/groups",
  ...e
}), cc = (e) => (e.client ?? y).post({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/groups",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e.headers
  }
}), uc = (e) => (e.client ?? y).get({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/namespaces",
  ...e
}), lc = (e) => (e.client ?? y).post({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/namespaces",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e.headers
  }
}), dc = (e) => (e.client ?? y).get({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/providers",
  ...e
}), fc = (e) => (e.client ?? y).delete({
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/requestable-accesses/{id}",
  ...e
}), pc = (e) => (e.client ?? y).put({
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/requestable-accesses/{id}",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e.headers
  }
}), hc = (e) => (e.client ?? y).get({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/requestable-accesses",
  ...e
}), mc = (e) => (e.client ?? y).post({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/requestable-accesses",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e.headers
  }
}), Ia = (e) => (e.client ?? y).get({
  querySerializer: { parameters: { where: { object: { style: "form" } } } },
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/resource-server-permissions/count",
  ...e
}), Oa = (e) => (e.client ?? y).get({
  querySerializer: { parameters: { filter: { object: { style: "form" } } } },
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/resource-server-permissions",
  ...e
}), Pa = (e) => (e.client ?? y).get({
  querySerializer: { parameters: { where: { object: { style: "form" } } } },
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/resource-servers/count",
  ...e
}), yc = (e) => (e.client ?? y).delete({
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/resource-servers/{id}/permissions/{permissionId}/access-roles/rel/{accessRoleId}",
  ...e
}), gc = (e) => (e.client ?? y).put({
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/resource-servers/{id}/permissions/{permissionId}/access-roles/rel/{accessRoleId}",
  ...e
}), xa = (e) => (e.client ?? y).delete({
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/resource-servers/{id}/permissions/{permissionId}",
  ...e
}), _a = (e) => (e.client ?? y).get({
  querySerializer: { parameters: { filter: { object: { style: "form" } } } },
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/resource-servers/{id}/permissions/{permissionId}",
  ...e
}), La = (e) => (e.client ?? y).patch({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/resource-servers/{id}/permissions/{permissionId}",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e.headers
  }
}), Na = (e) => (e.client ?? y).post({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/resource-servers/{id}/permissions",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e.headers
  }
}), qa = (e) => (e.client ?? y).delete({
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/resource-servers/{id}",
  ...e
}), ja = (e) => (e.client ?? y).get({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/resource-servers/{id}",
  ...e
}), Ua = (e) => (e.client ?? y).patch({
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/resource-servers/{id}",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e.headers
  }
}), ka = (e) => (e.client ?? y).get({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/resource-servers",
  ...e
}), Fa = (e) => (e.client ?? y).post({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/resource-servers",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e.headers
  }
}), bc = (e) => (e.client ?? y).get({
  querySerializer: { parameters: { filter: { object: { style: "form" } } } },
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/umrs-grants/group/{groupId}",
  ...e
}), Sc = (e) => (e.client ?? y).get({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/umrs-grants/group-assigment",
  ...e
}), wc = (e) => (e.client ?? y).delete({
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/umrs-grants/group-assignment/{id}",
  ...e
}), Rc = (e) => (e.client ?? y).put({
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/umrs-grants/group-assignment/{id}",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e.headers
  }
}), Ec = (e) => (e.client ?? y).post({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/umrs-grants/group-assignment",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e.headers
  }
}), Tc = (e) => (e.client ?? y).get({
  querySerializer: { parameters: { filter: { object: { style: "form" } } } },
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/umrs-grants/user/{userId}",
  ...e
}), Ac = (e) => (e.client ?? y).get({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/umrs-grants/user-assigment",
  ...e
}), Cc = (e) => (e.client ?? y).delete({
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/umrs-grants/user-assignment/{id}",
  ...e
}), vc = (e) => (e.client ?? y).put({
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/umrs-grants/user-assignment/{id}",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e.headers
  }
}), Ic = (e) => (e.client ?? y).post({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/umrs-grants/user-assignment",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e.headers
  }
}), Oc = (e) => (e.client ?? y).get({
  querySerializer: { parameters: { where: { object: { style: "form" } } } },
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/umrs-roles/count",
  ...e
}), Pc = (e) => (e.client ?? y).delete({
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/umrs-roles/{id}",
  ...e
}), xc = (e) => (e.client ?? y).get({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/umrs-roles/{id}",
  ...e
}), _c = (e) => (e.client ?? y).patch({
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/umrs-roles/{id}",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e.headers
  }
}), Lc = (e) => (e.client ?? y).get({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/umrs-roles",
  ...e
}), Nc = (e) => (e.client ?? y).post({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/umrs-roles",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e.headers
  }
}), qc = (e) => (e.client ?? y).get({
  querySerializer: { parameters: { where: { object: { style: "form" } } } },
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/users/count",
  ...e
}), jc = (e) => (e.client ?? y).get({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/users/{userId}/groups",
  ...e
}), Uc = (e) => (e.client ?? y).get({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/users/{id}",
  ...e
}), kc = (e) => (e.client ?? y).get({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/users",
  ...e
}), Fc = (e) => (e.client ?? y).post({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/admin/tenants/{tenantId}/users",
  ...e,
  headers: {
    "Content-Type": "application/json",
    ...e.headers
  }
}), Da = (e) => ((e == null ? void 0 : e.client) ?? y).get({
  responseType: "json",
  url: "/auth/domain-idp-mappings",
  ...e
}), Ba = (e) => ((e == null ? void 0 : e.client) ?? y).get({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/user/selfService/groups",
  ...e
}), $a = (e) => ((e == null ? void 0 : e.client) ?? y).get({
  responseType: "json",
  security: [{ scheme: "bearer", type: "http" }],
  url: "/auth/user/selfService/user",
  ...e
});
function X() {
  const e = vr();
  return y.setConfig({ axios: e, baseURL: e.defaults.baseURL ?? "" }), y;
}
function _e(e) {
  return X(), {
    query: Lr(e),
    querySerializer: Nr
  };
}
function Lr(e) {
  if (!e) return;
  const t = {};
  return e.filter != null && (t.filter = JSON.stringify(e.filter)), e.where != null && (t.where = JSON.stringify(e.where)), t;
}
function Nr(e) {
  const t = new URLSearchParams();
  for (const [r, n] of Object.entries(e))
    n != null && t.set(r, String(n));
  return t.toString();
}
function Ma() {
  const e = vr().defaults.baseURL;
  return j.create({ baseURL: e });
}
const za = {
  getBySlug(e) {
    const t = Ma();
    return va({
      axios: t,
      query: Lr({
        filter: {
          where: { tenantId: e },
          limit: 1
        }
      }),
      querySerializer: Nr
    });
  }
}, qr = G(null);
function Ga({ defaultTenantId: e, children: t }) {
  const [r, n] = ee(e), [s, o] = ee(null), [a, i] = ee(!0), [c, d] = ee(null);
  Q(() => {
    let l = !1;
    return i(!0), d(null), o(null), za.getBySlug(r).then((g) => {
      if (l) return;
      const w = g.data[0];
      w ? o(w.id) : d(`Tenant "${r}" not found`);
    }).catch((g) => {
      l || d(g instanceof Error ? g.message : "Failed to resolve tenant");
    }).finally(() => {
      l || i(!1);
    }), () => {
      l = !0;
    };
  }, [r]);
  const u = D((l) => {
    n(l);
  }, []);
  return /* @__PURE__ */ I(
    qr.Provider,
    {
      value: {
        tenantId: r,
        numericTenantId: s,
        isResolvingTenant: a,
        tenantResolutionError: c,
        setTenantId: u
      },
      children: t
    }
  );
}
function Me() {
  const e = k(qr);
  if (!e)
    throw new Error("useTenant must be used within a <TenantProvider>.");
  return e;
}
function Dc() {
  return Me().numericTenantId;
}
function Ha() {
  const e = Ca(), t = Yr(), r = xr(), n = W(!1);
  return Q(() => {
    if (n.current) return;
    n.current = !0;
    const s = aa();
    s && oa(() => e.request(Tr(s)), {
      queryClient: t,
      notify: r == null ? void 0 : r.notify
    });
  }, [e, t, r]), null;
}
const Va = {
  list(e, t) {
    return Oa({
      path: { tenantId: e },
      ..._e(t ? { filter: t } : void 0)
    });
  },
  count(e, t) {
    return Ia({
      path: { tenantId: e },
      ..._e(t ? { where: t } : void 0)
    });
  },
  getById(e, t, r) {
    return X(), _a({
      path: { tenantId: e, id: t, permissionId: r }
    });
  },
  create(e, t, r) {
    return X(), Na({
      path: { tenantId: e, id: t },
      body: r
    });
  },
  update(e, t, r, n) {
    return X(), La({
      path: { tenantId: e, id: t, permissionId: r },
      body: n
    });
  },
  delete(e, t, r) {
    return X(), xa({
      path: { tenantId: e, id: t, permissionId: r }
    });
  }
}, Wa = {
  list(e, t) {
    return ka({
      path: { tenantId: e },
      ..._e(t ? { filter: t } : void 0)
    });
  },
  getById(e, t) {
    return X(), ja({
      path: { tenantId: e, id: t }
    });
  },
  count(e, t) {
    return Pa({
      path: { tenantId: e },
      ..._e(t ? { where: t } : void 0)
    });
  },
  create(e, t) {
    return X(), Fa({
      path: { tenantId: e },
      body: { ...t, config: t.config ?? {} }
    });
  },
  update(e, t, r) {
    return X(), Ua({
      path: { tenantId: e, id: t },
      body: r
    });
  },
  delete(e, t) {
    return X(), qa({
      path: { tenantId: e, id: t }
    });
  }
}, Ja = ["openid", "profile", "email"], Bc = "admin::admin-permissions:edit", Ka = [
  "users",
  "groups",
  "roles",
  "permissions",
  "resourceServers",
  "umrsRoles",
  "umrsGrants",
  "namespaces"
], N = {
  users: {
    r: ["auth.users.list"],
    rw: ["auth.users.list", "auth.users.create", "auth.users.update", "auth.users.delete"]
  },
  groups: {
    r: ["auth.groups.list"],
    rw: ["auth.groups.list", "auth.groups.create", "auth.groups.update", "auth.groups.delete"]
  },
  roles: {
    r: ["auth.accessRoles.list"],
    rw: [
      "auth.accessRoles.list",
      "auth.accessRoles.create",
      "auth.accessRoles.update",
      "auth.accessRoles.delete",
      "auth.groups.manageAssignedNamespaceRoles"
    ]
  },
  permissions: {
    r: ["auth.resourceServerPermissions.list", "auth.resourceServers.list"],
    rw: [
      "auth.resourceServerPermissions.list",
      "auth.resourceServerPermissions.create",
      "auth.resourceServerPermissions.update",
      "auth.resourceServerPermissions.delete",
      "auth.resourceServers.list"
    ]
  },
  resourceServers: {
    r: ["auth.resourceServers.list"],
    rw: [
      "auth.resourceServers.list",
      "auth.resourceServers.create",
      "auth.resourceServers.update",
      "auth.resourceServers.delete"
    ]
  },
  /** `GET /umrs-roles` requires `auth.assigned.group.roles.list`; its count requires `auth.umrsRoles.list`. */
  umrsRoles: {
    r: ["auth.umrsRoles.list", "auth.assigned.group.roles.list"],
    rw: [
      "auth.umrsRoles.list",
      "auth.umrsRoles.create",
      "auth.umrsRoles.update",
      "auth.umrsRoles.delete",
      "auth.assigned.group.roles.list"
    ]
  },
  umrsGrants: {
    r: ["auth.umrsGrants.list"],
    /** Grant writes are authorized by UMRS role scopes; there are no `auth.umrsGrants.*` write scopes. */
    rw: ["auth.umrsGrants.list", "auth.umrsRoles.update", "auth.umrsRoles.delete"]
  },
  /** `GET /namespaces` requires `auth.assigned.group.roles.list`; its count requires `auth.namespaces.list`. */
  namespaces: {
    r: ["auth.namespaces.list", "auth.assigned.group.roles.list"],
    rw: ["auth.namespaces.list", "auth.namespaces.create", "auth.assigned.group.roles.list"]
  }
}, Ya = {
  users: "rw",
  groups: "rw",
  roles: "rw",
  permissions: "rw",
  resourceServers: "rw",
  umrsRoles: "rw",
  umrsGrants: "rw",
  namespaces: "rw"
};
function Mt(e, t, r) {
  for (const n of r)
    t.has(n) || (t.add(n), e.push(n));
}
function zt(e = {}) {
  const t = [], r = /* @__PURE__ */ new Set();
  Mt(t, r, Ja);
  for (const n of Ka) {
    const s = e[n] ?? "none";
    s !== "none" && Mt(t, r, N[n][s]);
  }
  return t.join(" ");
}
const $c = {
  /** `openid profile email` only — authentication without any Admin API access. */
  authOnly: zt(),
  /** `openid profile email` plus full CRUD `auth.*` scopes for every Clique entity. */
  all: zt(Ya)
}, Qa = {
  users: {
    list: N.users.rw[0],
    create: N.users.rw[1],
    update: N.users.rw[2],
    delete: N.users.rw[3]
  },
  groups: {
    list: N.groups.rw[0],
    create: N.groups.rw[1],
    update: N.groups.rw[2],
    delete: N.groups.rw[3]
  },
  roles: {
    list: N.roles.rw[0],
    create: N.roles.rw[1],
    update: N.roles.rw[2],
    delete: N.roles.rw[3]
  },
  permissions: {
    list: N.permissions.rw[0],
    create: N.permissions.rw[1],
    update: N.permissions.rw[2],
    delete: N.permissions.rw[3]
  },
  resourceServers: {
    list: N.resourceServers.rw[0],
    create: N.resourceServers.rw[1],
    update: N.resourceServers.rw[2],
    delete: N.resourceServers.rw[3]
  },
  umrsRoles: {
    list: N.umrsRoles.rw[0],
    create: N.umrsRoles.rw[1],
    update: N.umrsRoles.rw[2],
    delete: N.umrsRoles.rw[3]
  },
  /** UMRS grant mutations use the corresponding UMRS role scopes. */
  umrsGrants: {
    list: N.umrsGrants.rw[0],
    create: N.umrsRoles.rw[2],
    update: N.umrsRoles.rw[2],
    delete: N.umrsRoles.rw[3]
  }
}, Xa = {
  users: "users",
  groups: "groups",
  roles: "roles",
  permissions: "permissions",
  resourceServers: "resourceServers",
  umrsRoles: "umrsRoles",
  umrsGrants: "umrsGrants"
}, Za = {
  roles: { create: [["auth.accessRoles.create", "auth.groups.manageAssignedNamespaceRoles"]] },
  /** The list and its count call endpoints guarded by different scopes. */
  umrsRoles: { list: [["auth.umrsRoles.list"], ["auth.assigned.group.roles.list"]] }
};
function eo(e, t = "list") {
  return Qa[Xa[e]][t];
}
function ze(e, t = "list") {
  var r;
  return ((r = Za[e]) == null ? void 0 : r[t]) ?? [[eo(e, t)]];
}
function we(e, t) {
  return e.every((r) => r.some(t));
}
const to = [
  ["auth.assigned.group.roles.list", "admin::clients:edit"]
];
function Mc(e) {
  return e ? we(to, e) : !0;
}
function ro(e) {
  const t = e.split(".");
  if (t.length < 2 || !t[1])
    return null;
  try {
    const r = t[1].replace(/-/g, "+").replace(/_/g, "/"), n = r.padEnd(Math.ceil(r.length / 4) * 4, "="), s = atob(n), o = JSON.parse(s);
    return typeof o != "object" || o === null || Array.isArray(o) ? null : o;
  } catch {
    return null;
  }
}
function no(e) {
  return typeof e == "string" ? e.split(/\s+/).filter(Boolean) : Array.isArray(e) ? e.filter((t) => typeof t == "string" && t.length > 0) : [];
}
function so(e) {
  if (!e)
    return /* @__PURE__ */ new Set();
  const t = ro(e);
  return t ? new Set(no(t.scope ?? t.scp)) : /* @__PURE__ */ new Set();
}
const mt = G(null);
function ao({
  getAccessToken: e,
  gateComponents: t = !1,
  children: r
}) {
  const n = e(), s = F(() => so(n), [n]), o = F(
    () => ({
      scopes: s,
      gateComponents: t,
      hasScope: (a) => s.has(a),
      hasAllScopes: (...a) => a.every((i) => s.has(i)),
      hasAnyScope: (...a) => a.some((i) => s.has(i))
    }),
    [s, t]
  );
  return /* @__PURE__ */ I(mt.Provider, { value: o, children: r });
}
function yt() {
  const e = k(mt);
  if (!e)
    throw new Error("usePermissions must be used within a <PermissionsProvider>.");
  return e;
}
function jr() {
  return k(mt);
}
const oo = {
  canList: !0,
  canCreate: !0,
  canUpdate: !0,
  canDelete: !0
};
function zc(e) {
  const t = jr();
  return F(() => {
    if (!(t != null && t.gateComponents))
      return oo;
    const r = (n) => we(ze(e, n), t.hasScope);
    return {
      canList: r("list"),
      canCreate: r("create"),
      canUpdate: r("update"),
      canDelete: r("delete")
    };
  }, [t, e]);
}
function Gc(e) {
  return yt().hasScope(e);
}
function Hc(e, t = "list") {
  const { hasScope: r } = yt();
  return we(ze(e, t), r);
}
const io = [
  "users",
  "groups",
  "roles",
  "permissions",
  "resourceServers",
  "umrsRoles",
  "umrsGrants"
];
function Vc() {
  const { hasScope: e } = yt();
  return F(() => {
    const t = {};
    for (const r of io) {
      const n = (s) => we(ze(r, s), e);
      t[r] = {
        list: n("list"),
        create: n("create"),
        update: n("update"),
        delete: n("delete")
      };
    }
    return t;
  }, [e]);
}
function Le(e) {
  if (e === null)
    throw new Error(
      "Tenant ID is not resolved yet. Ensure tenant lookup has completed before making a tenant-scoped API call."
    );
  return e;
}
function co(e) {
  return e.replace(/[\\%_[\]]/g, "\\$&");
}
function Wc(e, t) {
  if (!t || e.length === 0) return;
  const r = `%${co(t)}%`;
  return e.length === 1 ? { [e[0]]: { like: r } } : { or: e.map((n) => ({ [n]: { like: r } })) };
}
function Jc(e, t) {
  return t == null ? e : e ? { and: [{ namespaceId: t }, e] } : { namespaceId: t };
}
function Kc(e, t) {
  if (t == null) return e;
  const r = Array.isArray(t) ? { resourceServerId: { inq: t } } : { resourceServerId: t };
  return e ? { and: [r, e] } : r;
}
function Yc(e, t = { id: !0, namespaceId: !0 }) {
  return [
    {
      relation: "resourceServer",
      required: !0,
      scope: { where: { namespaceId: e }, fields: t }
    }
  ];
}
function uo(e, t = { id: !0, identifier: !0 }) {
  return [
    {
      relation: "resourceServer",
      required: !0,
      scope: { where: { identifier: e }, fields: t }
    }
  ];
}
const Ur = G(null);
function Gt(e, t) {
  return e instanceof Error ? e.message : t;
}
function lo({
  identifier: e,
  id: t,
  showSelector: r = !1,
  scopePermissions: n = !0,
  children: s
}) {
  var P, A, C, T, L, q;
  const { numericTenantId: o } = Me(), a = jr(), i = t != null, c = a == null || we(ze("resourceServers", "list"), a.hasScope), d = o !== null && !i && c, u = pe({
    queryKey: ["resourceServerConfig", o, e],
    queryFn: () => Wa.list(Le(o), { where: { identifier: e } }).then((U) => U.data),
    enabled: d
  }), l = u.isError && Ar(u.error) === 403, g = o !== null && !i && (!c || l), w = pe({
    queryKey: ["resourceServerConfigFromPermission", o, e],
    queryFn: async () => {
      var $;
      const { data: U } = await Va.list(Le(o), {
        include: uo(e, {
          id: !0,
          identifier: !0,
          name: !0
        }),
        fields: { id: !0, resourceServerId: !0 },
        limit: 1
      }), B = U == null ? void 0 : U[0];
      if (!B) return null;
      if ((($ = B.resourceServer) == null ? void 0 : $.identifier) !== e)
        throw new Error(`Could not verify resource server "${e}" from its permissions`);
      return { id: B.resourceServerId, name: B.resourceServer.name ?? null };
    },
    enabled: g
  });
  let p = null, m = null, h = !1, S = null;
  i ? p = t : g ? (p = ((P = w.data) == null ? void 0 : P.id) ?? null, m = ((A = w.data) == null ? void 0 : A.name) ?? null, h = w.isPending, w.isError ? S = Gt(w.error, "Failed to resolve resource server") : w.isSuccess && w.data === null && (S = `Resource server "${e}" could not be resolved: this account cannot list resource servers and the server has no permissions yet. Configure its numeric id or grant auth.resourceServers.list.`)) : d ? (p = ((T = (C = u.data) == null ? void 0 : C[0]) == null ? void 0 : T.id) ?? null, m = ((q = (L = u.data) == null ? void 0 : L[0]) == null ? void 0 : q.name) ?? null, h = u.isPending, u.isError ? S = Gt(u.error, "Failed to resolve resource server") : u.isSuccess && u.data.length === 0 && (S = `Resource server "${e}" not found`)) : h = !0;
  const v = g ? w.refetch : u.refetch, O = F(
    () => ({
      resourceServerId: p,
      resourceServerName: m,
      resourceServerIdentifier: e,
      showSelector: r,
      scopePermissions: n,
      isResolving: h,
      resolutionError: S,
      refetch: () => {
        i || v();
      }
    }),
    [
      p,
      m,
      e,
      r,
      n,
      h,
      S,
      i,
      v
    ]
  );
  return /* @__PURE__ */ I(Ur.Provider, { value: O, children: s });
}
function Qc() {
  const e = k(Ur);
  if (!e)
    throw new Error(
      "useResourceServerConfig must be used within a <ResourceServerConfigProvider>."
    );
  return e;
}
const fo = {
  group: {
    singular: "group",
    plural: "groups",
    singularTitle: "Group",
    pluralTitle: "Groups",
    withArticle: "a group"
  },
  user: {
    singular: "user",
    plural: "users",
    singularTitle: "User",
    pluralTitle: "Users",
    withArticle: "a user"
  },
  role: {
    singular: "access role",
    plural: "access roles",
    singularTitle: "Access Role",
    pluralTitle: "Access Roles",
    withArticle: "an access role"
  },
  permission: {
    singular: "permission",
    plural: "permissions",
    singularTitle: "Permission",
    pluralTitle: "Permissions",
    withArticle: "a permission"
  },
  resourceServer: {
    singular: "resource server",
    plural: "resource servers",
    singularTitle: "Resource Server",
    pluralTitle: "Resource Servers",
    withArticle: "a resource server"
  },
  umrsRole: {
    singular: "UMRS role",
    plural: "UMRS roles",
    singularTitle: "UMRS Role",
    pluralTitle: "UMRS Roles",
    withArticle: "a UMRS role"
  },
  member: {
    singular: "member",
    plural: "members",
    singularTitle: "Member",
    pluralTitle: "Members",
    withArticle: "a member"
  },
  client: {
    singular: "client",
    plural: "clients",
    singularTitle: "Client",
    pluralTitle: "Clients",
    withArticle: "a client"
  },
  issuer: {
    singular: "issuer",
    plural: "issuers",
    singularTitle: "Issuer",
    pluralTitle: "Issuers",
    withArticle: "an issuer"
  },
  accessRequest: {
    singular: "access request",
    plural: "access requests",
    singularTitle: "Access Request",
    pluralTitle: "Access Requests",
    withArticle: "an access request"
  }
};
function po(e, t) {
  return t ? { ...e, ...t } : e;
}
function ho(e, t) {
  return Object.keys(e).reduce((r, n) => (r[n] = po(e[n], t[n]), r), {});
}
const at = G(fo);
function mo({ labels: e, children: t }) {
  const r = k(at), n = F(() => e ? ho(r, e) : r, [r, e]);
  return /* @__PURE__ */ I(at.Provider, { value: n, children: t });
}
function Xc() {
  return k(at);
}
const Zc = {
  Fallback: "fallback",
  Always: "always"
}, yo = {
  Day: "day",
  Minute: "minute",
  Second: "second"
}, eu = 7, tu = yo.Day, kr = G({});
function go({
  defaultIdentityIssuer: e,
  defaultIdentityIssuerMode: t,
  invitationApproveIn: r,
  invitationApproveInUnit: n,
  children: s
}) {
  const o = F(
    () => ({
      defaultIdentityIssuer: e,
      defaultIdentityIssuerMode: t,
      invitationApproveIn: r,
      invitationApproveInUnit: n
    }),
    [
      e,
      t,
      r,
      n
    ]
  );
  return /* @__PURE__ */ I(kr.Provider, { value: o, children: s });
}
function ru() {
  return k(kr);
}
const bo = {
  bg: "--clique-bg",
  bgSubtle: "--clique-bg-subtle",
  bgMuted: "--clique-bg-muted",
  fg: "--clique-fg",
  fgMuted: "--clique-fg-muted",
  fgSecondary: "--clique-fg-secondary",
  fgTertiary: "--clique-fg-tertiary",
  border: "--clique-border",
  borderSubtle: "--clique-border-subtle",
  primary: "--clique-primary",
  primaryFg: "--clique-primary-fg",
  primarySubtle: "--clique-primary-subtle",
  primaryMuted: "--clique-primary-muted",
  primaryStrong: "--clique-primary-strong",
  accent: "--clique-accent",
  accentSubtle: "--clique-accent-subtle",
  accentStrong: "--clique-accent-strong",
  destructive: "--clique-destructive",
  destructiveFg: "--clique-destructive-fg",
  destructiveSubtle: "--clique-destructive-subtle",
  destructiveBorder: "--clique-destructive-border",
  destructiveStrong: "--clique-destructive-strong",
  warning: "--clique-warning",
  radius: "--clique-radius",
  radiusLg: "--clique-radius-lg",
  radiusFull: "--clique-radius-full",
  shadow: "--clique-shadow",
  shadowLg: "--clique-shadow-lg",
  gradientFrom: "--clique-gradient-from",
  gradientTo: "--clique-gradient-to",
  sidebarBg: "--clique-sidebar-bg",
  sidebarFg: "--clique-sidebar-fg",
  sidebarFgMuted: "--clique-sidebar-fg-muted",
  sidebarBorder: "--clique-sidebar-border",
  sidebarActive: "--clique-sidebar-active",
  sidebarActiveAccent: "--clique-sidebar-active-accent",
  fontFamily: "--clique-font-family",
  fontSizeSm: "--clique-font-size-sm",
  fontSize: "--clique-font-size",
  fontSizeLg: "--clique-font-size-lg",
  fontWeightNormal: "--clique-font-weight-normal",
  fontWeightMedium: "--clique-font-weight-medium",
  fontWeightSemibold: "--clique-font-weight-semibold",
  fontWeightBold: "--clique-font-weight-bold",
  lineHeight: "--clique-line-height",
  spaceXs: "--clique-space-xs",
  spaceSm: "--clique-space-sm",
  spaceMd: "--clique-space-md",
  spaceLg: "--clique-space-lg",
  spaceXl: "--clique-space-xl",
  focusRing: "--clique-focus-ring",
  focusRingOffset: "--clique-focus-ring-offset",
  transition: "--clique-transition",
  transitionFast: "--clique-transition-fast",
  motionEase: "--clique-ease",
  zOverlay: "--clique-z-overlay",
  zModal: "--clique-z-modal"
}, So = {
  primaryColor: "--primary-color",
  primaryColorText: "--primary-color-text",
  surfaceGround: "--surface-ground",
  surfaceCard: "--surface-card",
  surfaceOverlay: "--surface-overlay",
  surfaceBorder: "--surface-border",
  surfaceHover: "--surface-hover",
  textColor: "--text-color",
  textColorSecondary: "--text-color-secondary",
  highlightBg: "--highlight-bg",
  highlightTextColor: "--highlight-text-color",
  borderRadius: "--border-radius",
  fontFamily: "--font-family"
};
function Ge(e) {
  return e.replace(/[<>{};]/g, "").trim();
}
function Fr(e, t, r) {
  const n = Object.keys(e).filter((s) => e[s] !== void 0).map((s) => `  ${t[s]}: ${Ge(e[s])};`);
  return n.length === 0 ? "" : `${r} {
${n.join(`
`)}
}`;
}
function Ht(e, t) {
  return Fr(e, bo, t);
}
function Vt(e, t) {
  return Fr(e, So, t);
}
const wo = {
  "#eff6ff": "--clique-p-primary-50",
  "#bfdbfe": "--clique-p-primary-200",
  "#3b82f6": "--clique-p-primary-500",
  "#2563eb": "--clique-p-primary-600",
  "#1d4ed8": "--clique-p-primary-700"
};
function nu(e, t = wo) {
  let r = e;
  for (const [n, s] of Object.entries(t))
    r = Dr(r, n, `var(${s}, ${n})`);
  return r;
}
function su(e, t) {
  const r = Ge(e);
  if (!r) return "";
  const s = [
    ["--clique-p-primary-50", `color-mix(in srgb, ${r} 10%, white)`],
    ["--clique-p-primary-200", `color-mix(in srgb, ${r} 35%, white)`],
    ["--clique-p-primary-500", r],
    ["--clique-p-primary-600", `color-mix(in srgb, ${r} 88%, black)`],
    ["--clique-p-primary-700", `color-mix(in srgb, ${r} 75%, black)`]
  ].map(([o, a]) => `  ${o}: ${a};`);
  return `${t} {
${s.join(`
`)}
}`;
}
const Ro = "--clique-pal-", Oe = "--clique-radius-override";
function Ne(e) {
  const t = e.toLowerCase();
  return t.length === 4 ? `#${t[1]}${t[1]}${t[2]}${t[2]}${t[3]}${t[3]}` : t;
}
function ce(e) {
  return `${Ro}${Ne(e).slice(1)}`;
}
function Eo(e) {
  if (e === void 0) return !1;
  const t = e.toLowerCase();
  return t >= "0" && t <= "9" || t >= "a" && t <= "f";
}
function Dr(e, t, r) {
  const n = e.toLowerCase(), s = t.toLowerCase();
  let o = "", a = 0;
  for (let i = n.indexOf(s, a); i !== -1; i = n.indexOf(s, a)) {
    o += e.slice(a, i);
    const c = i + s.length;
    o += Eo(n[c]) ? e.slice(i, c) : r, a = c;
  }
  return o += e.slice(a), o;
}
function To(e) {
  const t = {}, r = /(--[\w-]+)\s*:\s*(#[0-9a-fA-F]{3,8})\s*;/g;
  for (const n of e.matchAll(/:root\s*\{([^}]*)\}/g))
    for (const s of n[1].matchAll(r))
      t[s[1]] = s[2];
  return t;
}
function Ao(e) {
  const t = e.match(/:root\s*\{([^}]*)\}/);
  if (!t) return;
  const r = t[1].match(/--border-radius\s*:\s*([^;]+);/);
  return r ? r[1].trim() : void 0;
}
function Br(e) {
  const t = To(e), r = {};
  for (const [a, i] of Object.entries(t)) {
    const c = Ne(i);
    (r[c] ?? (r[c] = [])).push(a);
  }
  const n = /* @__PURE__ */ new Set(), s = [], o = /#[0-9a-fA-F]{6}(?![0-9a-fA-F])/g;
  for (const a of e.matchAll(o)) {
    const i = Ne(a[0]);
    n.has(i) || (n.add(i), s.push({ slot: ce(i), base: i, names: r[i] ?? [] }));
  }
  return { slots: s, borderRadius: Ao(e) };
}
function Co(e, t) {
  const r = t ?? Br(e);
  let n = e;
  if (r.borderRadius) {
    const s = r.borderRadius;
    n = n.replace(
      /border-radius\s*:\s*([^;}]+)/g,
      (o, a) => a.trim() === s ? `border-radius: var(${Oe}, ${s})` : o
    );
  }
  for (const { slot: s, base: o } of r.slots)
    n = Dr(n, o, `var(${s}, ${o})`);
  return n;
}
function $r(e) {
  return /^--[\w-]+$/.test(e);
}
function fe(e, t) {
  const r = Object.entries(e).filter(([n, s]) => $r(n) && s != null && s !== "").map(([n, s]) => `  ${n}: ${Ge(s)};`);
  return r.length === 0 ? "" : `${t} {
${r.join(`
`)}
}`;
}
const vo = [
  { label: "Primary", varName: "--primary-color" },
  { label: "Primary text", varName: "--primary-color-text" },
  { label: "Background", varName: "--surface-ground" },
  { label: "Card / surface", varName: "--surface-card" },
  { label: "Text", varName: "--text-color" },
  { label: "Text secondary", varName: "--text-color-secondary" },
  { label: "Border", varName: "--surface-border" },
  { label: "Highlight", varName: "--highlight-bg" },
  { label: "Highlight text", varName: "--highlight-text-color" }
];
function Io(e) {
  const t = [], r = /* @__PURE__ */ new Set();
  for (const { label: n, varName: s } of vo) {
    const o = e.slots.find((a) => a.names.includes(s));
    o && !r.has(o.slot) && (r.add(o.slot), t.push({ label: n, slot: o.slot, base: o.base }));
  }
  return t;
}
function Oo(e) {
  const t = /^#([0-9a-f]{6})$/.exec(Ne(e));
  if (!t) return null;
  const r = Number.parseInt(t[1], 16);
  return { r: r >> 16 & 255, g: r >> 8 & 255, b: r & 255 };
}
function Po(e, t, r) {
  const n = e / 255, s = t / 255, o = r / 255, a = Math.max(n, s, o), i = Math.min(n, s, o), c = (a + i) / 2, d = a - i;
  if (d === 0) return { h: 0, s: 0, l: c };
  const u = c > 0.5 ? d / (2 - a - i) : d / (a + i);
  let l;
  return a === n ? l = ((s - o) / d + (s < o ? 6 : 0)) * 60 : a === s ? l = ((o - n) / d + 2) * 60 : l = ((n - s) / d + 4) * 60, { h: l, s: u, l: c };
}
function xo({ h: e, s: t, l: r }) {
  const n = (1 - Math.abs(2 * r - 1)) * t, s = (e % 360 + 360) % 360 / 60 % 6, o = n * (1 - Math.abs(s % 2 - 1));
  let a = 0, i = 0, c = 0;
  s < 1 ? [a, i, c] = [n, o, 0] : s < 2 ? [a, i, c] = [o, n, 0] : s < 3 ? [a, i, c] = [0, n, o] : s < 4 ? [a, i, c] = [0, o, n] : s < 5 ? [a, i, c] = [o, 0, n] : [a, i, c] = [n, 0, o];
  const d = r - n / 2, u = (l) => Math.round((l + d) * 255).toString(16).padStart(2, "0");
  return `#${u(a)}${u(i)}${u(c)}`;
}
function Xe(e) {
  const t = Oo(e);
  return t ? Po(t.r, t.g, t.b) : null;
}
function _o(e, t) {
  const r = Math.abs(e - t) % 360;
  return r > 180 ? 360 - r : r;
}
const Lo = (e) => Math.min(1, Math.max(0, e)), No = 12, qo = 0.15;
function Wt(e) {
  return {
    [ce("#eff6ff")]: `color-mix(in srgb, ${e} 10%, white)`,
    [ce("#bfdbfe")]: `color-mix(in srgb, ${e} 35%, white)`,
    [ce("#3b82f6")]: e,
    [ce("#2563eb")]: `color-mix(in srgb, ${e} 88%, black)`,
    [ce("#1d4ed8")]: `color-mix(in srgb, ${e} 75%, black)`
  };
}
function Jt(e, t) {
  const r = Ge(e);
  if (!r) return {};
  if (!t) return Wt(r);
  const n = t.slots.find((d) => d.names.includes("--primary-color"));
  if (!n) return Wt(r);
  const s = Xe(n.base), o = Xe(r);
  if (!s || !o) return { [n.slot]: r };
  const a = o.h - s.h, i = s.s > 0.05 ? o.s / s.s : 1, c = {};
  for (const d of t.slots) {
    const u = Xe(d.base);
    !u || !(u.s >= qo && _o(u.h, s.h) <= No) || (c[d.slot] = xo({
      h: u.h + a,
      s: Lo(u.s * i),
      l: u.l
    }));
  }
  return c[n.slot] = r, c;
}
const Mr = G(null), zr = G(null), jo = "clique-primereact-theme", Uo = [
  { name: "lara-light-blue", label: "Lara Light Blue", family: "Lara", dark: !1 },
  { name: "lara-light-indigo", label: "Lara Light Indigo", family: "Lara", dark: !1 },
  { name: "lara-light-purple", label: "Lara Light Purple", family: "Lara", dark: !1 },
  { name: "lara-light-teal", label: "Lara Light Teal", family: "Lara", dark: !1 },
  { name: "lara-light-cyan", label: "Lara Light Cyan", family: "Lara", dark: !1 },
  { name: "lara-light-green", label: "Lara Light Green", family: "Lara", dark: !1 },
  { name: "lara-light-amber", label: "Lara Light Amber", family: "Lara", dark: !1 },
  { name: "lara-light-pink", label: "Lara Light Pink", family: "Lara", dark: !1 },
  { name: "lara-dark-blue", label: "Lara Dark Blue", family: "Lara", dark: !0 },
  { name: "lara-dark-indigo", label: "Lara Dark Indigo", family: "Lara", dark: !0 },
  { name: "lara-dark-purple", label: "Lara Dark Purple", family: "Lara", dark: !0 },
  { name: "lara-dark-teal", label: "Lara Dark Teal", family: "Lara", dark: !0 },
  { name: "lara-dark-cyan", label: "Lara Dark Cyan", family: "Lara", dark: !0 },
  { name: "lara-dark-green", label: "Lara Dark Green", family: "Lara", dark: !0 },
  { name: "lara-dark-amber", label: "Lara Dark Amber", family: "Lara", dark: !0 },
  { name: "lara-dark-pink", label: "Lara Dark Pink", family: "Lara", dark: !0 },
  { name: "soho-light", label: "Soho Light", family: "Soho", dark: !1 },
  { name: "soho-dark", label: "Soho Dark", family: "Soho", dark: !0 },
  { name: "viva-light", label: "Viva Light", family: "Viva", dark: !1 },
  { name: "viva-dark", label: "Viva Dark", family: "Viva", dark: !0 },
  { name: "saga-blue", label: "Saga Blue", family: "Saga", dark: !1 },
  { name: "saga-green", label: "Saga Green", family: "Saga", dark: !1 },
  { name: "saga-orange", label: "Saga Orange", family: "Saga", dark: !1 },
  { name: "saga-purple", label: "Saga Purple", family: "Saga", dark: !1 },
  { name: "arya-blue", label: "Arya Blue", family: "Arya", dark: !0 },
  { name: "arya-green", label: "Arya Green", family: "Arya", dark: !0 },
  { name: "arya-orange", label: "Arya Orange", family: "Arya", dark: !0 },
  { name: "arya-purple", label: "Arya Purple", family: "Arya", dark: !0 },
  { name: "md-light-indigo", label: "Material Light Indigo", family: "Material", dark: !1 },
  {
    name: "md-light-deeppurple",
    label: "Material Light Deep Purple",
    family: "Material",
    dark: !1
  },
  { name: "md-dark-indigo", label: "Material Dark Indigo", family: "Material", dark: !0 },
  {
    name: "md-dark-deeppurple",
    label: "Material Dark Deep Purple",
    family: "Material",
    dark: !0
  }
], Kt = "primereact-theme-style", Yt = "clique-token-style", Qt = "clique-palette-override";
function ko(e, t) {
  try {
    return localStorage.getItem(e) ?? t;
  } catch {
    return t;
  }
}
function Fo(e, t) {
  try {
    localStorage.setItem(e, t);
  } catch {
  }
}
function Do(e) {
  return typeof e != "object" || e === null ? !1 : Object.entries(e).every(
    ([t, r]) => $r(t) && typeof r == "string"
  );
}
function Bo(e) {
  return typeof e != "object" || e === null ? !1 : Object.values(e).every(Do);
}
function $o(e) {
  try {
    const t = localStorage.getItem(e);
    if (!t) return {};
    const r = JSON.parse(t);
    return Bo(r) ? r : {};
  } catch {
    return {};
  }
}
function Mo(e, t) {
  try {
    localStorage.setItem(e, JSON.stringify(t));
  } catch {
  }
}
const zo = (e) => `/themes/${e}/theme.css`;
function Go({
  defaultTheme: e = "lara-light-blue",
  themes: t = Uo,
  resolveThemeUrl: r = zo,
  cssLayer: n,
  tokens: s,
  darkTokens: o,
  primeTokens: a,
  primeDarkTokens: i,
  lockTheme: c = !1,
  storageKey: d = jo,
  children: u
}) {
  var $;
  const [l, g] = ee(
    () => c ? e : ko(d, e)
  ), w = W(r);
  w.current = r;
  const p = `${d}-tokens`, [m, h] = ee(null), [S, v] = ee(
    () => $o(p)
  ), O = (($ = t.find((R) => R.name === l)) == null ? void 0 : $.dark) ?? !1;
  Q(() => {
    const R = w.current(l), b = new AbortController();
    return h(null), fetch(R, { signal: b.signal }).then((x) => {
      if (!x.ok) throw new Error(`Theme CSS returned ${x.status}`);
      return x.text();
    }).then((x) => {
      let _ = document.getElementById(Kt);
      _ || (_ = document.createElement("style"), _.id = Kt, document.head.appendChild(_));
      const z = Br(x), H = Co(x, z);
      _.textContent = n ? `@layer ${n} {
${H}
}` : H, h(z);
    }).catch((x) => {
      x instanceof DOMException && x.name === "AbortError" || console.error("ThemeProvider: failed to load theme CSS", x);
    }), () => {
      b.abort();
    };
  }, [l, n]), Q(() => {
    document.documentElement.setAttribute("data-clique-mode", O ? "dark" : "light");
  }, [O]);
  const P = F(() => {
    const R = [];
    if (s) {
      const b = Ht(s, ":root");
      b && R.push(b);
    }
    if (a) {
      const b = Vt(a, ":root");
      b && R.push(b);
    }
    if (a != null && a.primaryColor) {
      const b = fe(
        Jt(a.primaryColor, m),
        ":root"
      );
      b && R.push(b);
    }
    if (a != null && a.borderRadius) {
      const b = fe(
        { [Oe]: a.borderRadius },
        ":root"
      );
      b && R.push(b);
    }
    if (o) {
      const b = Ht(o, ':root[data-clique-mode="dark"]');
      b && R.push(b);
    }
    if (i) {
      const b = Vt(i, ':root[data-clique-mode="dark"]');
      b && R.push(b);
    }
    if (i != null && i.primaryColor) {
      const b = fe(
        Jt(i.primaryColor, m),
        ':root[data-clique-mode="dark"]'
      );
      b && R.push(b);
    }
    if (i != null && i.borderRadius) {
      const b = fe(
        { [Oe]: i.borderRadius },
        ':root[data-clique-mode="dark"]'
      );
      b && R.push(b);
    }
    return R.join(`
`);
  }, [s, o, a, i, m]);
  Q(() => {
    const R = document.getElementById(Yt);
    if (!P) {
      R == null || R.remove();
      return;
    }
    let b = R;
    b || (b = document.createElement("style"), b.id = Yt, document.head.appendChild(b)), b.textContent = P;
  }, [P]);
  const A = D(
    (R) => {
      c || R !== l && (Fo(d, R), g(R));
    },
    [l, c, d]
  );
  Q(() => {
    Mo(p, S);
  }, [p, S]);
  const C = F(
    () => S[l] ?? {},
    [S, l]
  );
  Q(() => {
    const R = document.getElementById(Qt), b = fe(C, ":root:root");
    if (!b) {
      R == null || R.remove();
      return;
    }
    const x = R ?? document.createElement("style");
    R || (x.id = Qt, document.head.appendChild(x)), x.textContent = b;
  }, [C]);
  const T = D(
    (R, b) => {
      v((x) => ({
        ...x,
        [l]: { ...x[l], [R]: b }
      }));
    },
    [l]
  ), L = D(
    (R) => {
      v((b) => {
        const x = Object.fromEntries(
          Object.entries(b[l] ?? {}).filter(([_]) => _ !== R)
        );
        return { ...b, [l]: x };
      });
    },
    [l]
  ), q = D(() => {
    v((R) => R[l] ? Object.fromEntries(Object.entries(R).filter(([b]) => b !== l)) : R);
  }, [l]), U = F(() => m ? Io(m) : [], [m]), B = F(
    () => ({
      palette: m,
      curated: U,
      overrides: C,
      setToken: T,
      resetToken: L,
      resetAll: q,
      isCustomized: Object.keys(C).length > 0,
      radiusVar: Oe
    }),
    [m, U, C, T, L, q]
  );
  return /* @__PURE__ */ I(
    Mr.Provider,
    {
      value: { currentTheme: l, setTheme: A, themes: t, isDark: O, canSelectTheme: !c },
      children: /* @__PURE__ */ I(zr.Provider, { value: B, children: u })
    }
  );
}
function au() {
  const e = k(Mr);
  if (!e)
    throw new Error("useTheme must be used within a <ThemeProvider>.");
  return e;
}
function ou() {
  const e = k(zr);
  if (!e)
    throw new Error("useThemeCustomization must be used within a <ThemeProvider>.");
  return e;
}
const Gr = G({});
function Ho({ branding: e, children: t }) {
  const r = F(() => e ?? {}, [e]);
  return /* @__PURE__ */ I(Gr.Provider, { value: r, children: t });
}
function iu() {
  return k(Gr);
}
const Hr = G(null);
function qe(e) {
  if (e == null) return null;
  const t = e instanceof Date ? e : new Date(e);
  return Number.isNaN(t.getTime()) ? null : t;
}
function Vo({ config: e, children: t }) {
  const r = F(() => {
    const n = (e == null ? void 0 : e.emptyPlaceholder) ?? "—", s = (e == null ? void 0 : e.formatDate) ?? ((a) => a.toLocaleDateString(e == null ? void 0 : e.locale, e == null ? void 0 : e.dateOptions)), o = (e == null ? void 0 : e.formatDateTime) ?? ((a) => a.toLocaleString(
      e == null ? void 0 : e.locale,
      (e == null ? void 0 : e.dateTimeOptions) ?? { dateStyle: "medium", timeStyle: "short" }
    ));
    return {
      locale: e == null ? void 0 : e.locale,
      formatDate: (a) => {
        const i = qe(a);
        return i ? s(i) : n;
      },
      formatDateTime: (a) => {
        const i = qe(a);
        return i ? o(i) : n;
      }
    };
  }, [e]);
  return /* @__PURE__ */ I(Hr.Provider, { value: r, children: t });
}
function cu() {
  const e = k(Hr);
  return e || {
    locale: void 0,
    formatDate: (t) => {
      const r = qe(t);
      return r ? r.toLocaleDateString() : "—";
    },
    formatDateTime: (t) => {
      const r = qe(t);
      return r ? r.toLocaleString() : "—";
    }
  };
}
const ot = {
  create: "pi pi-plus",
  edit: "pi pi-pencil",
  delete: "pi pi-trash",
  remove: "pi pi-times",
  search: "pi pi-search",
  back: "pi pi-arrow-left",
  refresh: "pi pi-refresh",
  close: "pi pi-times",
  export: "pi pi-download",
  privileged: "pi pi-star",
  warning: "pi pi-exclamation-triangle",
  error: "pi pi-exclamation-circle",
  empty: "pi pi-inbox",
  group: "pi pi-users",
  user: "pi pi-user",
  role: "pi pi-shield",
  permission: "pi pi-lock",
  resourceServer: "pi pi-server",
  umrsRole: "pi pi-sitemap"
}, Vr = G(ot);
function Wo({ icons: e, children: t }) {
  const r = F(
    () => e ? { ...ot, ...e } : ot,
    [e]
  );
  return /* @__PURE__ */ I(Vr.Provider, { value: r, children: t });
}
function uu() {
  return k(Vr);
}
function Jo({
  tokens: e,
  darkTokens: t,
  primeTokens: r,
  primeDarkTokens: n,
  presetTheme: s,
  themes: o,
  resolveThemeUrl: a,
  lockTheme: i,
  cssLayer: c,
  storageKey: d,
  branding: u,
  format: l,
  icons: g,
  children: w
}) {
  return /* @__PURE__ */ I(
    Go,
    {
      defaultTheme: s,
      themes: o,
      resolveThemeUrl: a,
      cssLayer: c,
      storageKey: d,
      tokens: e,
      darkTokens: t,
      primeTokens: r,
      primeDarkTokens: n,
      lockTheme: i,
      children: /* @__PURE__ */ I(Ho, { branding: u, children: /* @__PURE__ */ I(Vo, { config: l, children: /* @__PURE__ */ I(Wo, { icons: g, children: w }) }) })
    }
  );
}
const He = G(null);
function Ko({
  enabled: e = !1,
  clientId: t,
  children: r
}) {
  const n = F(() => ({ enabled: e, clientId: t }), [e, t]);
  return /* @__PURE__ */ I(He.Provider, { value: n, children: r });
}
function lu() {
  const e = k(He);
  if (!e)
    throw new Error("useUserCreateConfig must be used within a <UserCreateConfigProvider>.");
  return e;
}
function du() {
  const e = k(He);
  return (e == null ? void 0 : e.enabled) ?? !1;
}
function fu() {
  const e = k(He);
  return e == null ? void 0 : e.clientId;
}
const Wr = G(void 0);
function Yo({ namespaceId: e, children: t }) {
  return /* @__PURE__ */ I(Wr.Provider, { value: e, children: t });
}
function Qo() {
  return k(Wr);
}
function pu(e) {
  const t = Qo();
  return e ?? t;
}
function Xo() {
  return new Xr({
    defaultOptions: {
      queries: {
        staleTime: 3e4,
        retry: 1
      }
    }
  });
}
function hu({
  baseURL: e,
  tenantId: t,
  getAccessToken: r,
  onLoginRequired: n,
  onStepUpRequired: s,
  queryClient: o,
  resourceServer: a,
  labels: i,
  defaultIdentityIssuer: c,
  invitationApprove: d,
  userCreate: u,
  theme: l,
  suppressForbiddenToast: g = !1,
  gateComponents: w = !1,
  namespaceId: p,
  children: m
}) {
  const h = F(() => o ?? Xo(), [o]), S = l ? /* @__PURE__ */ I(Jo, { ...l, children: m }) : m;
  return /* @__PURE__ */ I(Qr, { client: h, children: /* @__PURE__ */ I(Ta, { children: /* @__PURE__ */ he(
    Aa,
    {
      baseURL: e,
      getAccessToken: r,
      onLoginRequired: n,
      onStepUpRequired: s,
      queryClient: h,
      suppressForbiddenToast: g,
      children: [
        /* @__PURE__ */ I(Ha, {}),
        /* @__PURE__ */ I(Ga, { defaultTenantId: t, children: /* @__PURE__ */ I(ao, { getAccessToken: r, gateComponents: w, children: /* @__PURE__ */ I(
          lo,
          {
            identifier: a.identifier,
            id: a.id,
            showSelector: a.showSelector,
            scopePermissions: a.scopePermissions,
            children: /* @__PURE__ */ I(mo, { labels: i, children: /* @__PURE__ */ I(
              go,
              {
                defaultIdentityIssuer: c == null ? void 0 : c.value,
                defaultIdentityIssuerMode: c == null ? void 0 : c.mode,
                invitationApproveIn: d == null ? void 0 : d.in,
                invitationApproveInUnit: d == null ? void 0 : d.unit,
                children: /* @__PURE__ */ I(
                  Ko,
                  {
                    enabled: u == null ? void 0 : u.enabled,
                    clientId: u == null ? void 0 : u.clientId,
                    children: /* @__PURE__ */ I(Yo, { namespaceId: p, children: S })
                  }
                )
              }
            ) })
          }
        ) }) })
      ]
    }
  ) }) });
}
const Jr = {
  get(e) {
    return X(), $a({
      query: e != null ? { tenantId: e } : void 0
    });
  },
  getGroups(e) {
    return X(), Ba({
      query: e != null ? { tenantId: e } : void 0
    });
  }
}, Zo = {
  getForEmail(e) {
    return X(), Da({
      query: { email: e }
    });
  }
}, je = {
  all: ["userProfile"],
  byTenant: (e) => [...je.all, e],
  groups: (e) => [...je.all, e, "groups"]
};
function mu(e) {
  const { numericTenantId: t } = Me(), r = e ?? t;
  return pe({
    queryKey: je.byTenant(r),
    queryFn: () => Jr.get(Le(r)).then((n) => n.data),
    enabled: r != null
  });
}
function yu(e) {
  const { numericTenantId: t } = Me(), r = e ?? t;
  return pe({
    queryKey: je.groups(r),
    queryFn: () => Jr.getGroups(Le(r)).then((n) => n.data),
    enabled: r != null
  });
}
const Kr = {
  all: () => ["domainIdpMappings"],
  forEmail: (e) => [...Kr.all(), e]
};
function gu(e) {
  var r;
  const t = e.includes("@") && ((r = e.split("@")[1]) == null ? void 0 : r.includes("."));
  return pe({
    queryKey: Kr.forEmail(e),
    queryFn: () => Zo.getForEmail(e).then((n) => n.data),
    enabled: t,
    placeholderData: Zr,
    staleTime: 300 * 1e3
  });
}
export {
  Ic as $,
  vr as A,
  ki as B,
  Hi as C,
  Vi as D,
  Ji as E,
  Ki as F,
  Yi as G,
  yc as H,
  gc as I,
  Di as J,
  Bi as K,
  Mi as L,
  Gi as M,
  Fi as N,
  $i as O,
  zi as P,
  Pc as Q,
  _c as R,
  Nc as S,
  Oc as T,
  xc as U,
  Lc as V,
  wc as W,
  Cc as X,
  Rc as Y,
  vc as Z,
  Ec as _,
  rc as a,
  Yo as a$,
  bc as a0,
  Tc as a1,
  Sc as a2,
  Ac as a3,
  dc as a4,
  ji as a5,
  Ui as a6,
  lc as a7,
  uc as a8,
  Me as a9,
  ze as aA,
  Yc as aB,
  fu as aC,
  xr as aD,
  co as aE,
  Pi as aF,
  du as aG,
  au as aH,
  ou as aI,
  vi as aJ,
  Ii as aK,
  Bc as aL,
  Aa as aM,
  Ho as aN,
  Ja as aO,
  $c as aP,
  Qa as aQ,
  hu as aR,
  Jo as aS,
  ot as aT,
  Vo as aU,
  Wo as aV,
  yo as aW,
  go as aX,
  wo as aY,
  mo as aZ,
  to as a_,
  Le as aa,
  ru as ab,
  tu as ac,
  eu as ad,
  jr as ae,
  Wc as af,
  Ar as ag,
  Wa as ah,
  Va as ai,
  Qc as aj,
  Mc as ak,
  Jc as al,
  zc as am,
  pu as an,
  Xc as ao,
  j as ap,
  uu as aq,
  fa as ar,
  Oi as as,
  Zc as at,
  Zo as au,
  Kr as av,
  Kc as aw,
  cu as ax,
  Qo as ay,
  we as az,
  X as b,
  Ta as b0,
  Uo as b1,
  So as b2,
  ao as b3,
  Ys as b4,
  Ft as b5,
  Li as b6,
  Ir as b7,
  Ha as b8,
  Oe as b9,
  iu as bA,
  Hc as bB,
  gu as bC,
  Vc as bD,
  Gc as bE,
  qi as bF,
  yt as bG,
  Ni as bH,
  Dc as bI,
  lu as bJ,
  yu as bK,
  mu as bL,
  Jr as bM,
  je as bN,
  _i as bO,
  Or as bP,
  Pr as bQ,
  Sa as bR,
  bo as ba,
  Ga as bb,
  Go as bc,
  Ko as bd,
  Tr as be,
  eo as bf,
  zt as bg,
  pa as bh,
  Io as bi,
  $r as bj,
  Zs as bk,
  fe as bl,
  so as bm,
  Qs as bn,
  Br as bo,
  Jt as bp,
  su as bq,
  Vt as br,
  ya as bs,
  oa as bt,
  xi as bu,
  za as bv,
  nu as bw,
  Co as bx,
  Ht as by,
  Ca as bz,
  ec as c,
  nc as d,
  sc as e,
  oc as f,
  cc as g,
  Wi as h,
  ac as i,
  ic as j,
  Lr as k,
  Nr as l,
  jc as m,
  Fc as n,
  Uc as o,
  kc as p,
  Xi as q,
  _e as r,
  tc as s,
  Zi as t,
  qc as u,
  Qi as v,
  fc as w,
  pc as x,
  mc as y,
  hc as z
};
//# sourceMappingURL=useDomainIdpMapping.js.map
